// application.js

// ============================================================================
// Site
// ============================================================================
var SB                  = SB || {};
    SB.Global           = {};
    SB.Home             = {};
    SB.Product          = {};
    SB.Secondary        = {};
    SB.Collection       = {};

// ============================================================================
// Init
// ============================================================================
$(document).ready(function(){
  // GLOBAL
  new SB.Global.DesktopDropdown();
  new SB.Global.LazyLoadingBGImages();
  new SB.Global.MobileMenu();
  new SB.Global.ProductGridItem();
  new SB.Global.HideAlgolia();
  new SB.Global.PromoBar();

  // HOME
  if ($('.template-index').length) {
    new SB.Global.ModalPopup();

    if ($('.gift-guide__section').length) {
      new SB.Secondary.GiftGuidePromo();
    }
  }

  // COLLECTION
  if ($('.template-collection').length) {
    new SB.Collection.MobileShopBy();
    new SB.Collection.Filters();
    new SB.Collection.CollectionFiltering();
    new SB.Collection.SortByToggle();
    new SB.Collection.StickySidebar();
  }

  // PRODUCT: STANDARD
  if ($('.template-product').length) {
    new SB.Product.AddToCart();
    new SB.Product.Variants();
    new SB.Product.Slider();
    new SB.Product.ProductVariantState();
    new SB.Product.PDP2018();
    window.PERSONALIZATION_ENABLED && new SB.Product.Personalization();
  }

  // PRODUCT: T-SHIRT
  if ($('.template-product-shirt').length) {
    new SB.Product.VariantsShirt();
  }

  // PRODUCT: GIFT CARD
  if ($('.template-product-gift-card').length) {
    new SB.Product.VariantsGiftCard();
  }

  // CART
  if ( $('.template-cart').length ) {
    new SB.Secondary.CartTemplating();
    new SB.Secondary.GiftNoteCount();
  }

  // GiveBackPack
  if ($('.template-page-givebackpack').length) {
    new SB.Secondary.WDWTTKSliderMobile();
    new SB.Secondary.VideoPlayer();
  }

  // Projects
  if ($('.template-blog-projects').length) {
    new SB.Secondary.VideoPlayer();
  }

  if ($('.template-page-chicago').length) {
    new SB.Secondary.VideoPlayer();
  }

  if ( $('.template-customers-login').length ) {
    new SB.Secondary.AccountPasswordRecovery();
  }

  if ( $('.template-customers-account').length ) {
    new SB.Secondary.AccountOrderViewing();
  }

  if ( $('.template-customers-addresses').length ) {
    new SB.Secondary.AccountPage();
    new SB.Secondary.AddressSelectUI();
  }

  if ( $('.template-page-starwars').length ) {
    new SB.Secondary.StarWarsHero();
    new SB.Secondary.MobileProductSliderFriendshipOne();
    new SB.Secondary.MobileProductSliderFriendshipTwo();
    new SB.Secondary.MobileProductSliderFriendshipThree();
  }

  if ( $('.template-page-star-wars-sweepstakes').length ) {
    new SB.Secondary.SweepStakesForm();
  }

  if ( $('.template-page-sweepstakes').length ) {
    new SB.Secondary.SweepStakesForm();
  }

  if ( $('.template-page-you-and-yours').length ) {
    new SB.Secondary.YYSlider();
  }

  if ($('.template-page-gift-guide-wizard').length) {
    new SB.Secondary.GiftGuidePromo();
  }
});

$(window).on('load', function () {
  $('body').addClass('showtime');

  new SB.Global.MiniCart();

  // BLOG
  if ($('.template-blog').length) {
    new SB.Secondary.BlogViewMore();
  }

  if ( $('.template-page-faq').length ) {
    new SB.Secondary.FAQSidebar();
    new SB.Secondary.FAQSmoothScroll();
  }

  if ( $('.template-page-shop-by-style').length ) {
    new SB.Collection.CollectionSmoothScroll();
    new SB.Collection.StickySidebar();
  }

  if ( $('.template-page-star-wars-2').length ) {
    new SB.Collection.StickySidebar();
  }

  if ( $('.template-page-gift-guide').length ) {
    new SB.Collection.CollectionSmoothScroll();
    new SB.Collection.StickySidebar();
  }

  if ($('.template-cart').length) {
    new SB.Secondary.CartGiftWrapPreview();
  }

  if ($('.template-page-shop-by-style').length) {
    new SB.Secondary.ShopBySyle();
  }

});

// ============================================================================
// FUNCTIONS
// ============================================================================



// ----------------------------
// Polyfill to add ie11 includes support
// -----
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}
// ----------------------------
// Add Commas to Number
// ----------------------------
function addCommas(nStr) {
  nStr += '';
  x = nStr.split('.');
  x1 = x[0];
  x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
};

// ----------------------------
// Viewport Width and Height
// ----------------------------
 var viewportwidth;
 var viewportheight;

 // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight

 if (typeof window.innerWidth != 'undefined')
 {
      viewportwidth = window.innerWidth,
      viewportheight = window.innerHeight
 }

// IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)

 else if (typeof document.documentElement != 'undefined'
     && typeof document.documentElement.clientWidth !=
     'undefined' && document.documentElement.clientWidth != 0)
 {
       viewportwidth = document.documentElement.clientWidth,
       viewportheight = document.documentElement.clientHeight
 }

 // older versions of IE

 else
 {
       viewportwidth = document.getElementsByTagName('body')[0].clientWidth,
       viewportheight = document.getElementsByTagName('body')[0].clientHeight
 }

/*
 * Get Viewport Dimensions
 * returns object with viewport dimensions to match css in width and height properties
 * ( source: http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript )
*/
function updateViewportDimensions() {
  var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
  return { width:x,height:y };
}

// setting the viewport width
var viewport = updateViewportDimensions();

function refreshMiniCart() {
  var getFreshCart = function (callback) {
    var mainObject = {}
    var parents = {}
    var keyToLine = {}

    var counter = 1;

    $.ajax({
      url: '/cart.json',
      method: 'GET',
      dataType: 'JSON'
    })
      .done(function (dataResult) {
        var newCartItems = dataResult;
        var items = [];
        if (newCartItems.items) {
          items = newCartItems.items;
        } else {
          items = newCartItems;
        }
        for (let item of items) {
          // keep track of the line item order
          keyToLine[item.key] = counter
          counter += 1

          var product_type = item.product_type.toLowerCase();

          // if it doesn't have flare
          if (!item.properties) {
            mainObject[item.key] = {
              id: item.key,
              line: keyToLine[item.key],
              variantID: item.id,
              tags: "",
              title: item.product_title,
              handle: item.handle,
              totalPrice: item.line_price,
              price: 0,
              originalPrice: item.price,
              linePrice: (item.line_price / 100).toFixed(2),
              variant: (item.variant_options) ? item.variant_options[0] : null,
              image: item.image,
              url: item.url,
              personalizeID: 0,
              quantity: item.quantity,
              sku: item.sku,
              productType: item.product_type,
              giftWrapEnabled: true,
              giftWrap: {},
              subItems: []
            }
          } else if ((product_type === 'bag') || (product_type === 'tote')) {
            mainObject[item.key] = {
              id: item.key,
              line: keyToLine[item.key],
              variantID: item.id,
              tags: "",
              title: item.product_title,
              handle: item.handle,
              totalPrice: item.line_price,
              price: 0,
              linePrice: (item.line_price / 100).toFixed(2),
              originalPrice: item.price,
              variant: (item.variant_options) ? item.variant_options[0] : null,
              image: item.image,
              url: item.url,
              personalizeID: item.properties['personalize_id'],
              quantity: item.quantity,
              sku: item.sku,
              productType: item.product_type,
              giftWrapEnabled: true,
              giftWrap: {},
              subItems: []
            }

            parents[item.properties['personalize_id']] = item.key;
          } else if (item.product_title === 'E-Gift Note') {

            mainObject[item.key] = {
              id: item.key,
              line: keyToLine[item.key],
              variantID: item.id,
              tags: "",
              title: item.product_title,
              handle: item.handle,
              totalPrice: item.line_price,
              email: item.properties['email'],
              note: item.properties['note'],
              price: 0,
              originalPrice: item.price,
              linePrice: (item.line_price / 100).toFixed(2),
              variant: (item.variant_options) ? item.variant_options[0] : null,
              image: item.image,
              url: item.url,
              personalizeID: null,
              quantity: item.quantity,
              sku: item.sku,
              productType: item.product_type,
              giftWrapEnabled: false,
              giftWrap: {},
              subItems: []
            }
          }

        }

        for (let item of items) {

          var product_type = item.product_type.toLowerCase();

          var isPersonalizedItem = ((item.properties) && (product_type !== 'bag') && (product_type !== 'tote'))

          if (isPersonalizedItem && (item.properties['personalize_id'])) {

            var subItemPersonalizedID = item.properties['personalize_id']

            var main = mainObject[parents[subItemPersonalizedID]];

            if (main) {
              var orderValue = 0

              var productType = item.product_title;
              var display = item.product_title;

              if (item.product_title == 'Initials') {
                orderValue = 1;
                display = `"${item.properties['Text']}"`
              } else if (item.product_title == 'Symbol') {
                display = item.variant_options[0];
                orderValue = 2;
              } else if (item.product_type == 'patches') {
                orderValue = 3;
                productType = "Patch"
              } else if (item.product_type == 'Pin') {
                orderValue = 4;
                productType = "Pin"
              }

              mainObject[parents[subItemPersonalizedID]].totalPrice += item.line_price;

              var subItem = {
                id: item.key,
                line: keyToLine[item.key],
                orderValue: orderValue,
                variantID: item.id,
                title: item.product_title,
                price: 0,
                originalPrice: (item.price / 100).toFixed(2),
                linePrice: (item.line_price / 100).toFixed(2),
                variant: (item.variant_options) ? item.variant_options[0] : item.properties['Text'],
                image: item.image,
                text: item.properties['Text'],
                url: item.url,
                personalizeID: subItemPersonalizedID,
                quantity: item.quantity,
                sku: item.sku,
                display: display,
                productType: productType
              }

              mainObject[parents[subItemPersonalizedID]].subItems.push(subItem)
            }
          } else if (isPersonalizedItem && (item.properties['gift_wrap_id'])) {

            var subItemPersonalizedID = item.properties['gift_wrap_id']

            var main = mainObject[parents[subItemPersonalizedID]];

            mainObject[parents[subItemPersonalizedID]].totalPrice += item.line_price;

            if (main) {
              mainObject[parents[subItemPersonalizedID]].giftWrap = {
                id: item.key,
                line: keyToLine[item.key],
                variantID: item.id,
                title: item.product_title,
                price: 0,
                originalPrice: item.price,
                linePrice: (item.line_price / 100).toFixed(2),
                variant: (item.variant_options) ? item.variant_options[0] : null,
                image: item.image,
                text: item.properties['Text'],
                url: item.url,
                personalizeID: subItemPersonalizedID,
                quantity: item.quantity,
                sku: item.sku,
                productType: item.product_type
              }
            }
          }
        }

        var sortedItems = []
        for (var key in mainObject) {
          mainObject[key].subItems.sort(function (a, b) {
            return a.orderValue - b.orderValue;
          });

          mainObject[key].totalPrice = (mainObject[key].totalPrice / 100).toFixed(2)

          sortedItems.push(mainObject[key])
        }

        callback(sortedItems)
      });
    return false;
  }

  getFreshCart(function success(sortedItems) {
    $('.mini-cart-items').empty();

    setNewCart(sortedItems);
  })
}

function setNewCart(sortedItems) {

  var quantityCount = 0;
  var totalPrice = 0;

  for (let item of sortedItems) {

    var element =
      `<li class="mini-cart-item">
        <img src="${item.image}" class="lazyload" />
        <div class="mini-cart-item-info">
          <p class="mini-cart-item-title">${item.title}</p>
          <p class="item-type">${item.variant}</p>
          <p class="item-quantity">QTY: ${item.quantity}</p>
          <div class="mini-cart-item-price">
            <p class="regular-price" v-model="price">$${item.totalPrice}</p>
          </div>
        </div>`

    if (item.subItems.length > 0) {
      element +=
        `<div class="cart__item-personalization-block">
          <h5 class="cart__item-personalization-block-title">Personalization</h5>`
      for (let subItem of item.subItems) {

        // console.log(subItem);

        element += `
            <div class="personalization-row">
              <h5 class="personalization-initials-key">${subItem.productType}:</h5>
              <h5 class="personalization-initials-value">${subItem.display}, <span class="personalization-initials-price">$${subItem.originalPrice}</span></h5>
            </div> <!-- cart__item-personalization-block -->`
      }
      element +=
        `</div> <!-- cart__item-personalization-block -->`


    }

    if (Object.keys(item.giftWrap).length > 0) {
      element +=
        `<div class="cart__item-gift-wrap personalization-row">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"><path d="M7.0679,11.5 L1,11.5 L1,10.5 L7.0679,10.5 L7.0679,5.585 L0.999,5.585 L0.999,16.5 L7.0679,16.5 L7.0679,11.5 Z M14.135,10.5 L14.135,5.585 L8.0679,5.585 L8.0679,10.5 L14.135,10.5 Z M14.135,11.5 L8.0679,11.5 L8.0679,16.5 L14.135,16.5 L14.135,11.5 Z M3.13165325,4.585 C2.72542885,4.10004097 2.4809,3.47506617 2.4809,2.7928 C2.4809,1.24978093 3.73163416,-0.0002 5.2749,-0.0002 C6.22425435,-0.0002 7.06302822,0.473388337 7.5677086,1.19731548 C8.07224083,0.473329669 8.91096248,-0.0002 9.8608,-0.0002 C11.4032541,-0.0002 12.6538,1.24996923 12.6538,2.7928 C12.6538,3.47501936 12.4092818,4.10001486 12.0031297,4.585 L15.135,4.585 L15.135,17.5 L-0.001,17.5 L-0.001,4.585 L3.13165325,4.585 Z M5.22076111,4.585 L7.0678,4.585 L7.0678,2.7928 C7.0678,2.78781657 7.06781303,2.7828362 7.06783907,2.77785893 C7.05981453,1.79426347 6.26015285,0.9998 5.2749,0.9998 C4.2837841,0.9998 3.4809,1.80220058 3.4809,2.7928 C3.4809,3.76529846 4.2547104,4.55641306 5.22076111,4.585 Z M8.0678,4.585 L9.91488744,4.585 C10.8801039,4.55641091 11.6538,3.76518117 11.6538,2.7928 C11.6538,1.80232143 10.8510368,0.9998 9.8608,0.9998 C8.86994237,0.9998 8.0678,1.80194237 8.0678,2.7928 L8.0678,4.585 Z"></path></svg>
          <h5>Gift Wrap</h5>

          <h5 class="cart__item-gift-wrap-price">$5</h5>
        </div>`
    }

    element += '</li>'

    // Add latest item
    $('.mini-cart-items').append(element);

    totalPrice += parseFloat(item.totalPrice);

    quantityCount += item.quantity;
  }

  var updatedPrice = (totalPrice / 1).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');

  $(".js-mini-cart-subtotal").html("$" + updatedPrice);

  console.log("___Total Price____", totalPrice);

  $('.js-cart-count').html(quantityCount);

  $('.nav-right').css('opacity', '1');
}


/*
 * Throttle Resize-triggered Events
 * Wrap your actions in this function to throttle the frequency of firing them off, for better performance, esp. on mobile.
 * ( source: http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed )
*/
var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
    if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

// how long to wait before deciding the resize has stopped, in ms. Around 50-100 should work ok.
var timeToWaitForLast = 100;

/*
 * Timing Functions
*/
var functionStart = window.performance.now();
var functionComplete = window.performance.now();
var functionTime = functionComplete - functionStart;

// console.log('Function Title started at ' + String(functionStart) + ' and ended at ' + String(functionComplete));
// console.log('Function Title took ' + String(functionTime));

(function(jQuery) {
   jQuery.fn.clickoutside = function(callback) {
      var outside = 1, self = $(this);
      self.cb = callback;
      this.click(function() {
         outside = 0;
      });
      $(document).click(function() {
         outside && self.cb();
         outside = 1;
      });
      return $(this);
   }
})(jQuery);

// ----------------------------
// YouTube Player
// ----------------------------
function autoPlayYouTubeModal() {
  var a = $("body").find('[data-toggle="modal"]');

  a.click(function() {
    // console.log('video');
    var a = $(this).data("target"),
        b = $(this).attr("data-theVideo"),
        c = b + "?rel=0&autoplay=1";
    $(a + " iframe").attr("src", c), $(a + " a.close").click(function() {
      $(a + " iframe").attr("src", b)
    })
  }), $("#videoModal").on("hidden.bs.modal", function() {
    $("#videoModal iframe").removeAttr("src")
  })
}

/*! getClosest.js | (c) 2017 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/getClosest */
/**
 * Get the closest parent element that matches a selector.
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 */
var getClosest = function ( elem, selector ) {

  // Element.matches() polyfill
  if (!Element.prototype.matches) {
      Element.prototype.matches =
          Element.prototype.matchesSelector ||
          Element.prototype.mozMatchesSelector ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.oMatchesSelector ||
          Element.prototype.webkitMatchesSelector ||
          function(s) {
              var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                  i = matches.length;
              while (--i >= 0 && matches.item(i) !== this) {}
              return i > -1;
          };
  }

  // Get closest match
  for ( ; elem && elem !== document; elem = elem.parentNode ) {
      if ( elem.matches( selector ) ) return elem;
  }

  return null;
};

// ============================================================================
// GLOBAL
// ============================================================================
SB.Global.LazyLoadingBGImages = function() {
  document.addEventListener('lazybeforeunveil', function(e){
      var bg = e.target.getAttribute('data-bg');
      if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
      }
  });
};

SB.Global.HideAlgolia = function() {
  $(document).click(function(e) {

    if ($(e.target).closest(".algolia-autocomplete").length === 0) {
      $(".algolia-autocomplete").hide();
      $(".search").val("");
    }
  })
};

SB.Global.ProductGridItem = function() {
  $('.collection-matrix').on({
    mouseenter: function () {
      var $parentContainer = $(this).parents(".product-grid-item");

      var $firstImage = $parentContainer.find(".product-thumb").first();
      var $secondImage = $firstImage.next();

      $firstImage.attr("src", $(this).data("image-one"))
      $secondImage.attr("src", $(this).data("image-two"))

      $parentContainer.find(".product-thumb-wrap").attr("href", $(this).data("href"))
      $parentContainer.find(".product-text-wrap").attr("href", $(this).data("href"))
      $parentContainer.find(".variant_id").val($(this).data("var-id"))
    },
    mouseleave: function () {
      var $parentContainer = $(this).parents(".product-grid-item");
      var $firstImage = $parentContainer.find(".product-thumb").first();
      var $secondImage = $firstImage.next();
      $firstImage.attr("src", $firstImage.attr("data-src"))
      $secondImage.attr("src", $secondImage.attr("data-src"))
      $parentContainer.find(".product-thumb-wrap").attr("href", $parentContainer.find(".product-thumb-wrap").attr("data-href"))
      $parentContainer.find(".product-text-wrap").attr("href", $parentContainer.find(".product-text-wrap").attr("data-href"))
    }
  }, '.variant-swatch');

  $('.collection-matrix').on({
    mouseenter: function () {
      var $parentContainer = $(this).parents(".product-grid-item");
      $parentContainer.removeClass("alt-image")
    },
    mouseleave: function () {

      var $parentContainer = $(this).parents(".product-grid-item");
      $parentContainer.addClass("alt-image")

    }
  }, '.product-colors');

  $(".sorting__toggle").click(function() {
    $(".sort-by-options").toggle();
  })
};

SB.Global.PromoBar = function() {
  var promoBarVisible = false;

  if ( $('.header.promo-bar--visible').length ) {
    var promoBarVisible = true;
  }

  // is the promo bar active?
  if ( promoBarVisible ) {
    if ( $(window).width() >= 641 ) {
      $(document).on("scroll", function(){
        if ($(document).scrollTop() > 30) {
          $('.header').addClass('stuck');
          $('.page').addClass('stuck');
          $('.dept_nav').addClass('stuck');
        } else {
          $('.header').removeClass('stuck');
          $('.page').removeClass('stuck');
          $('.dept_nav').removeClass('stuck');
        }
      });
    } else {
      $(document).on("scroll", function(){
        if ($(document).scrollTop() > 26) {
          $('.header').addClass('stuck');
        } else {
          $('.header').removeClass('stuck');
        }
      });
    }
  }
}


SB.Global.DesktopDropdown = function() {
  // Tricky Fading On Nav Links
  var $links = $('.header-dropdown-triggers .nav-item, .nav-right .nav-item');

  $links.mouseenter(function() {
    $links.addClass('faded');
    $(this).addClass('active');

    var index = $(this).data('index');
  });

  $links.mouseleave(function() {
    $(this).removeClass('active');
    $links.removeClass('faded');

    var index = $(this).data('index');
  });

  // Dropdown Toggles
  var $menuWrapper  = $('.header-desktop-drop'),
      $menus        = $('.header-drop-menu'),
      $body         = $('body');

  var timer;

  $('.dropdown-toggle').hover(function() {
    var data = $(this).data('menu'),
        $this = $(this);

    var navItemHover = function() {
      $('.dropdown-toggle').removeClass('active');
      $this.addClass('active');
      $menus.removeClass('active');
      $body.addClass('nav-open');
      $body.attr('data-nav', data);
    }

    clearTimeout(timer);

    timer = setTimeout(
      navItemHover
    , 400);
  }, function() {
    clearTimeout(timer);

    setTimeout(function() {
      if ($('.header-desktop-drop:hover').length > 0 || $('.dropdown-toggle:hover').length > 0) {
      } else {
        clearTimeout(timer);
        $body.removeClass('nav-open');
        $menuWrapper.removeClass('active');
        $('.dropdown-toggle').removeClass('active');
      }
    }, 0);
  });

  // Hide Dropdown when hovering from menu to non-dropdown nav link
  $('.dropdown-kill').hover(function() {
    $body.removeClass('nav-open');
    $menuWrapper.removeClass('active');
    $('.dropdown-toggle').removeClass('active');
  });

  // Make sure the menu stays open when you hover inside of it
  $('.header-desktop-drop').hover(function() {
    var $menu = $(this);
    $body.addClass('nav-open');
    $menuWrapper.addClass('active');
  }, function() {
    setTimeout(function() {
      if ($('.header-desktop-links:hover').length > 0) {
      } else {
        $body.removeClass('nav-open');
        $menuWrapper.removeClass('active');
        $('.dropdown-toggle').removeClass('active');
      }
    }, 200);
  });
};

SB.Global.MiniCart = function() {
  window.hadError = false;

  var showMiniCart = function() {
    if ( CartJS.cart.items.length > 0 ) {
      $('.mini-cart').show();
      $('.icon-cart').addClass('inverse');
    } else {
      // console.log('no products')
    }
  }

  var hideMiniCart = function() {
    $('.mini-cart').hide();
    $('.icon-cart').removeClass('inverse');
  }

  // Mini Cart on Hovering Cart Icon in Header
  // $('.js-mini-cart-trigger').hoverIntent(showMiniCart);
  $('.js-mini-cart-trigger').mouseenter(function() {
    showMiniCart();
  }).mouseleave(function(){
    hideMiniCart();
  });

  $('.mini-cart').mouseenter(function() {
    showMiniCart();
  }).mouseleave(function() {
    hideMiniCart();
  });

  $('.mini-cart').clickoutside(hideMiniCart);

  $('.js-close-mini-cart').on('click', function() {
    hideMiniCart();
    $('.icon-cart').removeClass('inverse');
  });

  // @TODO
  // if cart is empty do not show mini cart

  refreshMiniCart();

  $('.collection-matrix').on({
    click: function () {
      var $this = $(this).closest('.qs-form').find('.qs-variant'),
          $thisBTN = $(this),
          variantProductTitle = $this.data('product-title'),
          variantTitle = $this.data("variant-title"),
          variantId = $this.data("variant-id"),
          variantImage = $this.data("variant-image"),
          variantSalePrice = $this.data('variant-sale-price'),
          variantPrice = $this.data('variant-price');

      $(document).on('cart.requestStarted', function(event, cart) {
        $thisBTN.val('Adding to bag').addClass('disabled').prop('disabled', true);
      });

      $(document).on('cart.requestComplete', function(event, cart) {
        // Pinterest Trackingg
        pintrk('track', 'AddToCart');

        // Empty Mini Cart
        $('.mini-cart-items').empty();

        if ( hadError == true ) {
          $this.closest('.qs-form').find('.qs-submit').val('Error');
          // console.log('error')
        } else {
          $this.closest('.qs-form').find('.qs-submit').val('Added!').addClass('disabled').prop('disabled', true);

          // Update Header Cart Count

          refreshMiniCart();

          $('.mini-cart').show();

          $('.mini-cart').clickoutside(function(){
            $(this).hide();
            $('.icon-cart').removeClass('inverse');
          });
        }
      });
    },
    mouseleave: function () {
    }
  }, '.qs-submit');

  // quick shop
  $('.qs-submit').on('click', function() {
    var $this = $(this).closest('.qs-form').find('.qs-variant'),
        $thisBTN = $(this),
        variantProductTitle = $this.data('product-title'),
        variantTitle = $this.data("variant-title"),
        variantId = $this.data("variant-id"),
        variantImage = $this.data("variant-image"),
        variantSalePrice = $this.data('variant-sale-price'),
        variantPrice = $this.data('variant-price');

    $(document).on('cart.requestStarted', function(event, cart) {
      $thisBTN.val('Adding to bag').addClass('disabled').prop('disabled', true);
    });

    $(document).on('cart.requestComplete', function(event, cart) {
      // Pinterest Trackingg
      pintrk('track', 'AddToCart');

      // Empty Mini Cart
      $('.mini-cart-items').empty();

      if ( hadError == true ) {
        $this.closest('.qs-form').find('.qs-submit').val('Error');
        // console.log('error')
      } else {
        $this.closest('.qs-form').find('.qs-submit').val('Added!').addClass('disabled').prop('disabled', true);

        // Update Header Cart Count

        refreshMiniCart();

        $('.mini-cart').show();

        $('.mini-cart').clickoutside(function(){
          $(this).hide();
          $('.icon-cart').removeClass('inverse');
        });
      }
    });



  });
}

SB.Global.MobileMenu = function() {
  $('.js-mobile-menu-toggle .icon-menu').on('click', function() {
    window.currentPosVertical = $(window).scrollTop();

    $('body').addClass('fixed');
    $('.mobile-menu-navigation').addClass('active');
    $('.icon-menu').hide();
    $('.icon-menu-close').show();
    // console.log('you opened the menu at ' + currentPosVertical)
  });

  $('.js-mobile-menu-toggle .icon-menu-close').on('click', function() {
    $('body').removeClass('fixed');
    $('.mobile-menu-navigation').removeClass('active');
    $('.icon-menu').show();
    $('.icon-menu-close').hide();

    $('body').animate({
      scrollTop: currentPosVertical,
    }, 0);

    // console.log('you closed it and are back at ' + currentPosVertical);
  });

  $('.mobile-nav-section').on('click', function() {
    $(this).toggleClass('active');
  });

  // Toggle Between Mobile Menu Lists
  $('.mobile-menu-header-link').on('click', function() {
      var menu = $(this).data('menu');
      var $links = $('.mobile-menu-header-link');
      var $menus = $('.mobile-menu-departments');

      $links.removeClass('active');
      $(this).addClass('active');
      $menus.find('.department-menu').removeClass('active');
      $menus.find("[data-menu='" + menu + "']").addClass('active');

      console.log(menu);
      console.log($menus.find("[data-menu='" + menu + "']"));
  });
};


SB.Global.ModalPopup = function() {
  var $closeNewsletterModal = $('.newsletter-modal, .newsletter-modal .close-modal');
  var cookie = Cookies.get('sb_newsletter');

  // Check if Cookie exists, if not, display bar
  if ( cookie == undefined ) {
    setTimeout(function() {
      $("#newsletterModal").modal("show");
    }, 2000);
  }

  // Close Newsletter Bar
  $closeNewsletterModal.on('click', function(e) {
    if (($(e.target).closest(".modal-content").length === 0) || $(this).hasClass("close-modal")) {
      $("#newsletterModal").modal('hide');
      $('body').removeClass('newsletter-bar-visible');
      Cookies.set('sb_newsletter', { expires: 30 });
    }
  });
};


// ============================================================================
// HOME
// ============================================================================

// ============================================================================
// COLLECTION
// ============================================================================
SB.Collection.MobileShopBy = function() {
  var $collectionSortByDropdown = $('#collectionSortByDropdown'),
      $mobileShopByTrigger = $('#mobileShopByTrigger'),
      $shopByLabel = $('.js-shop-by-label');

  var openSortByDropdown = function() {
    $collectionSortByDropdown.css({display: 'block', visibility: 'visible'});
    $mobileShopByTrigger.find('.js-shop-by-label').addClass('active');
    $shopByLabel.addClass('active');
  };

  var closeSortByDropdown = function() {
    $collectionSortByDropdown.css({display: 'none', visibility: 'hidden'});
    $mobileShopByTrigger.find('.js-shop-by-label').removeClass('active');
    $shopByLabel.removeClass('active');
  };

  $mobileShopByTrigger.on('click', function() {
    if ($collectionSortByDropdown.css('display') === 'none') {
      openSortByDropdown();
    } else {
      closeSortByDropdown();
    }
  });
};


SB.Collection.CollectionFiltering = function() {

  $(".sorting__toggle").click(function() {
    $(".sort-by-options").toggle();
  })

  $("body").click(function(){
    $(".sort-by-options").hide();
  });

  $(document).click(function(e) {
    if ($(e.target).closest(".col-initial-holder").length === 0) {
      $(".col-placement-select__options").hide();
      $(".col-placement-select__value").removeClass("selected")
    }
  })

  $(".sorting__toggle").click(function(e){
    e.stopPropagation();
  });

  $(".sort-by-option").click(function(e) {

    var sortValue = $(this).data("sort-value");

    var matrix = $('.collection-main-body'), items = matrix.children('.product-grid-item');

    if (sortValue === "price-ascending") {
      items.detach().sort(function(a,b) {
        return parseInt(a.dataset.price) - parseInt(b.dataset.price);
      });
    } else if (sortValue === "price-descending") {
      items.detach().sort(function(a,b) {
        return parseInt(b.dataset.price) - parseInt(a.dataset.price);
      });
    } else {
      items.detach().sort(function(a,b) {
        return parseInt(a.dataset.featured) - parseInt(b.dataset.featured);
      });
    }

    matrix.append(items);
  });

  Array.prototype.isInArrayOr = function (array) {
    var isValueIncluded = false;
    for(var i = 0; i < this.length; i++) {

      if (array.includes(this[i])) {
        isValueIncluded = true;
      }
    }

    return isValueIncluded;
  }

  Array.prototype.isInArrayAnd = function (array) {

    if (this.length > array.length) {return false;}

    var counter = 0;
    for(var i = 0; i < this.length; i++) {
      counter += (array.includes(this[i])) ? 1 : 0;
    }

    return counter === this.length;
  }

  $(".col-placement-select__value").click(function(){
    $(this).next().hide()
  })

  var store = {
    cartItems: [],
    showColors: false,
    colorBoxes: [],
    materialBoxes: [],
    capacityBoxes: [],
    availableSelections: [],
    colorTags: COLOR_TAGS.filter((v, i, a) => a.indexOf(v) === i),
    materialTags: MATERIAL_TAGS.filter((v, i, a) => a.indexOf(v) === i),
    capacityTags: CAPACITY_TAGS.filter((v, i, a) => a.indexOf(v) === i)
  }

  var allCollectionProducts = '';
  var hasFetchedProducts = false;
  var isFetchingProducts = false;


  var actions = {
    toggleOptions: function (event) {
      //$(".col-placement-select__options").hide();
      //$(".col-placement-select__value").removeClass("selected")
      var $currentClicked = $(event.target)

      $currentClicked.toggleClass("selected")
      $currentClicked.next().toggle();

      $(".col-placement-select__value").each(function() {
        if (!$(this).is($currentClicked)) {
          $(this).removeClass("selected")
          $(this).next().hide();
        }
      })
    },
    getAllProducts: function () {

      if (hasFetchedProducts) return;

      var currentPage = 1;

      var fetchNextPage = function() {
        $.get(COLLECTION_PRODUCTION_ENDPOINT + '&limit=250&page=' + currentPage + '&sort_by=' + COLLECTION_SORT, function(res) {
          if (res.indexOf('END_OF_COLLECTION') > -1) {
            isFetchingProducts = false;
            $('#fetchedProducts').find('.collection-matrix').append($(allCollectionProducts));
            $('#paginatedProducts').show();
            actions.checkedChanged();
          } else {
            allCollectionProducts += res;
            currentPage++;
            fetchNextPage();
          }
        });
      };

      hasFetchedProducts = true;
      isFetchingProducts = true;
      fetchNextPage();
    },
    toggleMobile: function () {
      $("body").toggleClass("no-scroll")
      $(".collection-filtering-body-header-mobile").toggleClass("selected")
      $(".col-initial-holder").toggle();
      $(".collection-filtering-body").toggleClass("filter-showing")
      $(".apply-filters").toggleClass("hidden")
    },
    checkedChanged: function() {
      actions.filterItems();
      $(".collection-pagination").hide();
    },
    filterItems: function() {
      var htmlSearch = $("#fetchedProducts .collection-matrix").html()
      $('#paginatedProducts .collection-matrix').html(htmlSearch);

      store.colorBoxes.sort((a, b) => a.localeCompare(b))
      store.materialBoxes.sort((a, b) => a.localeCompare(b))
      store.capacityBoxes.sort((a, b) => a.localeCompare(b))

      store.availableSelections = []

      $(".product-grid-item").each(function() {
        var colorBoxArray = $(this).data("colors").split(',').sort((a, b) => a.localeCompare(b));
        var materialBoxArray = $(this).data("materials").split(',').sort((a, b) => a.localeCompare(b));
        var capacityBoxArray = $(this).data("fits").split(',').sort((a, b) => a.localeCompare(b));

        var $currentItem = $(this);
        $currentItem.removeClass("hidden").show();

        // if checked colors or checked materials or checked capacities are in there show it
        var showColors = false;
        var showMaterials = false;
        var showCapacities = false;

        var somethingsChecked = ((store.colorBoxes.length > 0) || (store.materialBoxes.length > 0) || (store.capacityBoxes.length > 0))


        if (store.colorBoxes.length > 0) {
          showColors = store.colorBoxes.isInArrayOr(colorBoxArray);
        }

        if ((store.materialBoxes.length > 0)) {
          showMaterials = store.materialBoxes.isInArrayOr(materialBoxArray);
        }

        if ((store.capacityBoxes.length > 0)) {
          showCapacities = store.capacityBoxes.isInArrayOr(capacityBoxArray);
        }

        if (somethingsChecked) {
          if (showColors || showMaterials || showCapacities)  {
            $(this).removeClass("hidden").show();
          } else {
            $(this).addClass("hidden").hide();
          }

          if (store.colorBoxes.length > 0 && ((store.materialBoxes.length > 0) || (store.capacityBoxes.length > 0))) {

            if (!showColors && (store.colorBoxes.length > 0)) {
              $(this).addClass("hidden").hide();
            }

            if (showColors) {



              if (!showMaterials && (store.materialBoxes.length > 0)) {
                $(this).addClass("hidden").hide();
              }

              if (!showCapacities && (store.capacityBoxes.length > 0)) {
                $(this).addClass("hidden").hide();
              }

            }
          }
        }

        if (!$(this).hasClass( "hidden" )) {
          //store.availableSelections.push.apply(store.availableSelections, colorBoxArray);
          //store.availableSelections.push.apply(store.availableSelections, materialBoxArray);
          //store.availableSelections.push.apply(store.availableSelections, capacityBoxArray);
        }
      });
    },
    notAvailable: function(tag) {
      return ((store.availableSelections.length > 0) && (!store.availableSelections.includes(tag)));
    },
    clearAll: function() {
      store.colorBoxes = []
      store.materialBoxes = []
      store.capacityBoxes = []

      actions.checkedChanged();
    },
    clearFilters: function() {
      actions.clearAll();
      actions.toggleMobile();
    },
    totalSelected: function() {
      return store.colorBoxes.length + store.materialBoxes.length + store.capacityBoxes.length
    },
    formatText: function(currentText) {
      return currentText.replace("-", " ")
    },
    parentClicked: function(event, catType) {

      var $parent = $(event.target)

      if (!$parent.hasClass("col-filter-select") || $parent.hasClass("disabled")) {return false};

      var $input = $parent.children("input")

      if ($input.is(':checked')) {

        if (catType === "color") {
          var index = store.colorBoxes.indexOf($input.val());

          store.colorBoxes.splice(index, 1);

        } else if(catType === "material") {

          var index = store.materialBoxes.indexOf($input.val());

          store.materialBoxes.splice(index, 1);

        } else if(catType === "capacity") {

          var index = store.capacityBoxes.indexOf($input.val());

          store.capacityBoxes.splice(index, 1);
        }

      } else {

        if (catType === "color") {

          store.colorBoxes.push($input.val())

        } else if(catType === "material") {

          store.materialBoxes.push($input.val())

        } else if(catType === "capacity") {

          store.capacityBoxes.push($input.val())

        }
      }

      actions.checkedChanged();
    }
  }

  var view = new Vue({
    el: '#collectionFiltering',
    data: store,
    methods: {
      checkedChanged: actions.checkedChanged,
      toggleOptions: function (event) {
        return actions.toggleOptions(event)
      },
      toggleMobile: function () {
        return actions.toggleMobile()
      },
      notAvailable: function (tag) {
        return actions.notAvailable(tag)
      },
      totalSelected: function () {
        return actions.totalSelected()
      },
      formatText: function (currentText) {
        return actions.formatText(currentText)
      },
      parentClicked: function (event, catType) {
        return actions.parentClicked(event, catType)
      },
      clearAll: actions.clearAll,
      clearFilters: actions.clearFilters,
    },
    mounted: function () {
      var $vm = this;
      var $el = $(this.$el);

      var url = new URL(window.location.href);
      var color = url.searchParams.get("color");
      var material = url.searchParams.get("material");
      var capacity = url.searchParams.get("capacity");

      if (color) {
        var $parent = $(".col-initial-row:eq(0)")

        $parent.find(".col-placement-select__value").addClass("selected");
        $parent.find(".col-placement-select__options").show();

        store.colorBoxes.push.apply(store.colorBoxes, color.split(","));
      } else if (material) {
        var $parent = $(".col-initial-row:eq(1)")

        $parent.find(".col-placement-select__value").addClass("selected");
        $parent.find(".col-placement-select__options").show();

        store.materialBoxes.push.apply(store.materialBoxes, material.split(","));
      } else if (capacity) {
        var $parent = $(".col-initial-row:eq(2)")

        $parent.find(".col-placement-select__value").addClass("selected");
        $parent.find(".col-placement-select__options").show();

        store.capacityBoxes.push.apply(store.capacityBoxes, capacity.split(","));
      }

      actions.getAllProducts();
    }
  });
}

SB.Collection.Filters = function() {
  var $desktopFiltersTrigger = $('#desktopFiltersTrigger');
  var $mobileFiltersTrigger = $('#mobileFiltersTrigger');
  var $filtersClose = $('.close-filter-dropdown');
  var $mobileEmptyFilters = $('#mobileEmptyFilters');
  var $mobileActiveFilters = $('#mobileActiveFilters');
  var $mobileActiveFilterCount = $('#mobileActiveFilterCount');
  var $collectionFiltersDropdown = $('#collectionFiltersDropdown');
  var $desktopActiveFilters = $('#desktopActiveFilters');
  var $filterOptions = $('[data-filter-tag]');
  var $desktopApplyFilters = $('.desktop-collection-filter-submit');
  var $desktopSort = $('.desktop-collection-sort');
  var $clearCollectionFilters = $('.collection-filter-clear');
  var $applyCollectionFilters = $('.collection-filter-apply');
  var $paginatedProducts = $('#paginatedProducts');
  var $fetchedProducts = $('#fetchedProducts');
  var $window = $(window);
  var $body = $('body');

  //
  // === Open/Close Dropdown Behavior ===
  //

  var stopPropagation = function(e) {
    e.stopPropagation();
  }

  var openFiltersDropdown = function() {
    fetchCollectionProducts();
    resetTemporaryTags();
    updateFilterDropdownSelection(activeTags);
    $collectionFiltersDropdown.css({display: 'block', visibility: 'visible'});
    $desktopApplyFilters.css({display: 'block', visibility: 'visible'});
    $desktopSort.css({display: 'none', visibility: 'hidden'});
    $mobileFiltersTrigger.addClass('active');
    $body.addClass('filter-menu-open');

    // Close when clicking outside dropdown
    // Defer adding click listener to window until dropdown is open
    setTimeout(function() {
      $window.on('click', closeFiltersDropdown);
      $collectionFiltersDropdown.on('click', stopPropagation);
      $clearCollectionFilters.on('click', stopPropagation);
      $applyCollectionFilters.on('click', stopPropagation);
    });
  };

  var closeFiltersDropdown = function() {
    $collectionFiltersDropdown.css({display: 'none', visibility: 'hidden'});
    $desktopApplyFilters.css({display: 'none', visibility: 'hidden'});
    $desktopSort.css({display: 'block', visibility: 'visible'});
    $mobileFiltersTrigger.removeClass('active');
    $body.removeClass('filter-menu-open');

    // Remove close listeners
    $window.off('click', closeFiltersDropdown);
    $collectionFiltersDropdown.off('click', stopPropagation);
    $clearCollectionFilters.off('click', stopPropagation);
    $applyCollectionFilters.off('click', stopPropagation);
  };

  var toggleFiltersDropdown = function() {
    if ($collectionFiltersDropdown.css('display') === 'none') {
      openFiltersDropdown();
    } else {
      closeFiltersDropdown();
    }
  };

  // Open dropdown by clicking trigger
  $mobileFiltersTrigger.click(toggleFiltersDropdown);
  $desktopFiltersTrigger.click(toggleFiltersDropdown);
  $filtersClose.click(toggleFiltersDropdown);


  // Sorting Dropdown
  var openSortingDropdown = function() {
    // $('.desktop-collection-sort-active').css({display: 'block', visibility: 'visible'});
    $('.js-sort-by-options').css({display: 'block', visibility: 'visible'});
    $body.addClass('filter-menu-open');

    // Close when clicking outside dropdown
    // Defer adding click listener to window until dropdown is open
    setTimeout(function() {
      $window.on('click', closeSortingDropdown);
    });
  };

  var closeSortingDropdown = function() {
    // $('.desktop-collection-sort-active').css({display: 'none', visibility: 'hidden'});
    $('.js-sort-by-options').css({display: 'none', visibility: 'hidden'});
    $body.removeClass('filter-menu-open');

    // Remove close listeners
    $window.off('click', closeSortingDropdown);
  };

  var toggleSortDropdown = function() {
    if ($('.js-sort-by-options').css('display') === 'none') {
      openSortingDropdown();
    } else {
      closeSortingDropdown();
    }
  };

  // Open dropdown by clicking trigger
  $('.js-desktop-collection-sort-trigger').click(toggleSortDropdown);

  //
  // === All Collection Tags ===
  //
  var colorTags = [];
  var materialTags = [];
  var fitsTags = [];
  var collectionTagNames = {};

  var isColorTag = function(tag) {
    return tag.indexOf('color-') === 0;
  };

  var isMaterialTag = function(tag) {
    return tag.indexOf('fabric-') === 0;
  };

  var isFitsTag = function(tag) {
    return tag.indexOf('fits-') === 0;
  }

  $.each(ALL_COLLECTION_TAGS, function(index, tag) {
    if (isColorTag(tag)) {
      colorTags.push(tag.slice(6).replace(' ', '-').toLowerCase());
    }

    if (isMaterialTag(tag)) {
      materialTags.push(tag.slice(7).replace(' ', '-').toLowerCase());
    }

    if (isFitsTag(tag)) {
      fitsTags.push(tag.slice(7).replace(' ', '-').toLowerCase());
    }
  });

  //
  // === Fetch Collection Products ===
  //

  var allCollectionProducts = '';
  var hasFetchedProducts = false;
  var isFetchingProducts = false;

  var fetchCollectionProducts = function() {
    if (hasFetchedProducts) return;

    var currentPage = 1;

    var fetchNextPage = function() {
      $.get(COLLECTION_PRODUCTION_ENDPOINT + '&limit=250&page=' + currentPage + '&sort_by=' + COLLECTION_SORT, function(res) {
        if (res.indexOf('END_OF_COLLECTION') > -1) {
          isFetchingProducts = false;
          $fetchedProducts.find('.collection-matrix').append($(allCollectionProducts));
        } else {
          allCollectionProducts += res;
          currentPage++;
          fetchNextPage();
        }
      });
    };

    hasFetchedProducts = true;
    isFetchingProducts = true;
    fetchNextPage();
  };

  //
  // === Enable/Disable Filters ===
  //

  var activeTags = [];
  var tagsToApply = [];

  var resetTemporaryTags = function() {
    tagsToApply = activeTags.slice(0);
  }

  // Update Dropdown View
  var updateFilterDropdownSelection = function(selectedTags) {
    $filterOptions.removeClass('filter-selected filter-unavailable');

    if (selectedTags.length === 0) { return; }

    $filterOptions.each(function() {
      var $this = $(this);
      var tag = $this.data('filter-tag');

      if ($.inArray(tag, selectedTags) > -1) {
        $this.addClass('filter-selected')
      } else if (!isFilterSelectionAvailable(selectedTags.concat([tag]))) {
        $this.addClass('filter-unavailable');
      }
    });
  };

  // Update Active Filters
  var updateActiveFilterList = function() {
    if (activeTags.length === 0) {
      $desktopActiveFilters.html('<svg class="icon-plus" width="8px" height="8px" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="R2" stroke="none" stroke-width="1" fill="#000000" fill-rule="evenodd"><path fill="#000000" d="M7.756,4.024 C7.756,3.716 7.504,3.506 7.21,3.506 L4.732,3.506 L4.732,0.944 C4.732,0.636 4.55,0.398 4.228,0.398 C3.906,0.398 3.71,0.636 3.71,0.944 L3.71,3.506 L1.246,3.506 C0.966,3.506 0.7,3.744 0.7,4.024 C0.7,4.332 0.952,4.514 1.246,4.514 L3.71,4.514 L3.71,7.076 C3.71,7.356 3.948,7.622 4.228,7.622 C4.55,7.622 4.732,7.384 4.732,7.076 L4.732,4.514 L7.21,4.514 C7.504,4.514 7.756,4.332 7.756,4.024 Z" id="+" fill="#000000"></path></g></svg>');
      $mobileActiveFilterCount.html('Filter <svg class="icon-plus" width="8px" height="8px" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="R2" stroke="none" stroke-width="1" fill="#000000" fill-rule="evenodd"><path fill="#000000" d="M7.756,4.024 C7.756,3.716 7.504,3.506 7.21,3.506 L4.732,3.506 L4.732,0.944 C4.732,0.636 4.55,0.398 4.228,0.398 C3.906,0.398 3.71,0.636 3.71,0.944 L3.71,3.506 L1.246,3.506 C0.966,3.506 0.7,3.744 0.7,4.024 C0.7,4.332 0.952,4.514 1.246,4.514 L3.71,4.514 L3.71,7.076 C3.71,7.356 3.948,7.622 4.228,7.622 C4.55,7.622 4.732,7.384 4.732,7.076 L4.732,4.514 L7.21,4.514 C7.504,4.514 7.756,4.332 7.756,4.024 Z" id="+" fill="#000000"></path></g></svg>');
      $mobileActiveFilters.css({display: 'none'});
      $mobileEmptyFilters.css({display: 'block'});
    } else {
      var displayActiveTags = activeTags.map(function(t) {return t.replace('-', ' ')});
      var displayActiveTagsList = displayActiveTags.join(', ');

      $mobileActiveFilters.css({display: 'block'}).text(displayActiveTagsList);
      $mobileEmptyFilters.css({display: 'none'});

      $desktopActiveFilters.text(activeTags.length);
      $mobileActiveFilterCount.text('Filter (' + activeTags.length + ')');
    }
  };

  // Check if specific filter is available
  var isFilterSelectionAvailable = function(filterSelection) {
    var $products = $('#fetchedProducts .product-grid-item');
    var matchedProductCount = 0;

    $products.each(function() {
      var productColors = this.dataset.colors ? this.dataset.colors.split(',') : [];
      var productMaterials = this.dataset.materials ? this.dataset.materials.split(',') : [];
      var productFits = this.dataset.fits ? this.dataset.fits.split(',') : [];

      var matchColor = true;
      var matchMaterials = true;
      var matchFits = true;

      // If we have an active tag in a category,
      // we no longer match
      $.each(filterSelection, function(index, tag) {
        if ($.inArray(tag, colorTags) > -1) {
          matchColor = false;
        }
        if ($.inArray(tag, materialTags) > -1) {
          matchMaterials = false;
        }
        if ($.inArray(tag, fitsTags) > -1) {
          matchFits = false;
        }
      });

      // Match by category
      $.each(productColors, function(index, color) {
        if ($.inArray(color, filterSelection) > -1) {
          matchColor = true;
        }
      });

      $.each(productMaterials, function(index, material) {
        if ($.inArray(material, filterSelection) > -1) {
          matchMaterials = true;
        }
      });

      $.each(productFits, function(index, fit) {
        if ($.inArray(fit, filterSelection) > -1) {
          matchFits = true;
        }
      });

      if (matchColor && matchMaterials && matchFits) {
        matchedProductCount++;
      }
    });

    return matchedProductCount > 0 ? true : false;
  };

  // Update Fetched Products list
  var updateFilteredProducts = function() {
    var $products = $('#fetchedProducts .product-grid-item');

    $products.each(function() {
      var productColors = this.dataset.colors ? this.dataset.colors.split(',') : [];
      var productMaterials = this.dataset.materials ? this.dataset.materials.split(',') : [];
      var productFits = this.dataset.fits ? this.dataset.fits.split(',') : [];

      var matchColor = false;
      var matchMaterials = false;
      var matchFits = false;

      if (activeTags.length < 1) {
          // Match if we don't have any filters
        matchColor = true;
        matchMaterials = true;
        matchFits = true;
      } else {
        // If we have an active tag in a category,
        // we no longer match
        matchColor = true;
        matchMaterials = true;
        matchFits = true;
        $.each(activeTags, function(index, tag) {
          if ($.inArray(tag, colorTags) > -1) {
            matchColor = false;
          }
          if ($.inArray(tag, materialTags) > -1) {
            matchMaterials = false;
          }
          if ($.inArray(tag, fitsTags) > -1) {
            matchFits = false;
          }
        });
      }

      // Match by category
      $.each(productColors, function(index, color) {
        if ($.inArray(color, activeTags) > -1) {
          matchColor = true;
        }
      });

      $.each(productMaterials, function(index, material) {
        if ($.inArray(material, activeTags) > -1) {
          matchMaterials = true;
        }
      });

      $.each(productFits, function(index, fit) {
        if ($.inArray(fit, activeTags) > -1) {
          matchFits = true;
        }
      });

      if (!matchColor || !matchMaterials || !matchFits) {
        $(this).css({display: 'none', visibility: 'hidden'});
      } else {
        $(this).css({display: 'inline-block', visibility: 'visible'});
      }
    });
  };

  // Show Fetched Products
  var showFetchedProducts = function() {
    $paginatedProducts.css({display: 'none', visibility: 'hidden'});
    $fetchedProducts.css({display: 'block', visibility: 'visible'});
  };

  // Update Temporary Tags
  $filterOptions.click(function() {
    var $this = $(this);
    var tag = $this.data('filter-tag');

    // Only apply to available classes
    if ($this.hasClass('filter-unavailable')) { return; }

    if ($.inArray(tag, tagsToApply) > -1) {
      tagsToApply = $.grep(tagsToApply, function(t) {
        return t !== tag
      });
    } else {
      tagsToApply.push(tag);
    }

    updateFilterDropdownSelection(tagsToApply)
  });

  //
  // === Apply Updates ===
  //

  var closeDropdownApplyUpdates = function() {
    closeFiltersDropdown();
    showFetchedProducts();
    updateFilteredProducts();
    updateActiveFilterList();
    window.scrollTo(0,0);
  };

  $applyCollectionFilters.click(function() {
    activeTags = tagsToApply;
    closeDropdownApplyUpdates();
  });

  $clearCollectionFilters.click(function() {
    activeTags = [];
    tagsToApply = [];
    closeDropdownApplyUpdates();
  });
};

SB.Collection.SortByToggle = function() {
  var dropdownVisibleContainer = $('.js-sort-by-options'),
      dropdownItemsContainer = $('.js-sort-by-collection-selection'),
      dropdownUILabel = $('.js-desktop-sort-by-ui-label');

  // set UI label, only if one active
  if ( window.location.href.indexOf('?') > -1) {
    $(dropdownUILabel).text($(dropdownItemsContainer).find('option:selected').text());
  }
  $(dropdownUILabel).addClass('loaded');

  // Build options
  $(dropdownItemsContainer).find('option').each( function() {
    var optionText = $(this).text(),
        optionValue = $(this).val();
    $(dropdownVisibleContainer).append('<h5 class="sort-by-option" data-sort-value="' + optionValue + '">' + optionText + '</h5>');
  });

  // Option Selected
  $('.sort-by-option').on('click', function() {
    var sortOption = $(this).text(),
        sortValue = $(this).data('sort-value');

    $(dropdownUILabel).text(sortOption);
    $(dropdownVisibleContainer).removeClass('active');

    $(dropdownItemsContainer).find('option[value=' + sortValue + ']').attr('selected','selected');
    $(dropdownItemsContainer).change();
  });
};

// ============================================================================
// PRODUCT
// ============================================================================
// sale price and cartjs?
SB.Product.AddToCart = function() {
  $('.js-add-to-cart-desktop').on('click', function() {
    var $this = $(this).closest('.info-form').find('input[type="hidden"]'),
        $thisBTN = $(this),
        variantProductTitle = $this.data('product-title'),
        variantTitle = $this.data("variant-title"),
        variantId = $this.data("variant-id"),
        variantImage = $this.data("variant-image"),
        variantSalePrice = $this.data('variant-sale-price'),
        variantPrice = $this.data('variant-price');

    $(document).on('cart.requestStarted', function(event, cart) {
      $thisBTN.val('Adding to bag').addClass('disabled').prop('disabled', true);
    });

    $(document).on('cart.requestComplete', function(event, cart) {
      // Pinterest Trackingg
      pintrk('track', 'AddToCart');

      // Chatbot Tracking
      window.hl_fbm_add_to_cart.optIn();

      // Empty Mini Cart
      $('.mini-cart-items').empty();

      if ( hadError == true ) {
        $this.closest('.info-form').find('.js-add-to-cart-desktop').val('Error');
        // console.log('error')
      } else {
        $this.closest('.info-form').find('.js-add-to-cart-desktop').val('Added!').addClass('disabled').prop('disabled', true);

        setTimeout(function() {
          $this.closest('.info-form').find('.js-add-to-cart-desktop').val('Add to Bag').removeClass('disabled').prop('disabled', false);
        }, 500);

        $('.icon-cart').addClass('inverse');

        refreshMiniCart();
        // if ( variantSalePrice ) {
        //   $('.mini-cart-items').find('.mini-cart-item').find('.regular-price').css('color', 'red');
        // }

        $('.mini-cart').show();

        $('.mini-cart').clickoutside(function(){
          $(this).hide();
          $('.icon-cart').removeClass('inverse');
        });
      }
    });
  });
};

SB.Product.Variants = function() {
  var variantOnLoad = $('.info-variants .variant-swatch.active'),
      variantPrice = $(variantOnLoad).data('variant-price'),
      variantSalePrice = $(variantOnLoad).data('variant-sale-price'),
      variantStock = $(variantOnLoad).data('variant-stock'),
      $personalizeBlock = $('.btn-personalize'),
      $bisBlock = $('.bis-block');;

  // Price On Load
  if ( variantSalePrice == '' ) {
    $('.js-product-sale-price').html('');
    $('.js-product-price').html(variantPrice).css('color', 'black');
  } else {
    $('.js-product-sale-price').html(variantSalePrice);
    $('.js-product-price').html(variantPrice).css('color', 'red');
  }

  // Inventory On Load
  if ( variantStock == "out-of-stock") {
    $personalizeBlock.hide();
    $bisBlock.show();
    $('.js-add-to-cart-stock').val('Out Of Stock').addClass('disabled').prop('disabled', true);
  }

  $('.product-pricing').show();

  // Variant swatch UI
  $('.info-variants .variant-swatch').on('click', function() {
    var $this = $(this),
        variantTitle = $this.data("variant-title"),
        productTitle = $this.data("product-title"),
        variantHandle = $this.data("variant-handle"),
        variantId = $this.data("variant-id"),
        variantImage = $this.data("variant-image"),
        variantStock = $this.data("variant-stock"),
        $colorLabel = $this.closest('.info-variants').find('.variants-label-value'),
        $idInput = $this.closest('.wrap').find('#variantId'),
        $gallery = $('.product-main-gallery').find("[data-variant-id='" + variantId + "']"),
        variantPrice = $(this).data('variant-price'),
        variantSalePrice = $(this).data('variant-sale-price');

    // Price Updating
    if ( variantSalePrice == '' ) {
      $('.js-product-sale-price').html('');
      $('.js-product-price').html(variantPrice).css('color', 'black');
    } else {
      $('.js-product-sale-price').html(variantSalePrice);
      $('.js-product-price').html(variantPrice).css('color', 'red');
    }

    $('.js-add-to-cart-stock').removeClass('disabled').prop('disabled', false).val('Add To Bag');

    // Reset all swatches
    // $this.siblings().removeClass('active');

    // Select new active swatch
    // $this.addClass('active');

    // Update color label
    // $colorLabel.html(variantTitle);

    // Set Variant ID form field
    // $idInput.val(variantId);

    // Display variant gallery
    // $('.product-gallery').removeClass('active');
    // $gallery.addClass('active');

    // stock check
    if ( variantStock == "out-of-stock" ) {
      $personalizeBlock.hide();
      $bisBlock.show();
      $('.js-add-to-cart-stock').val('Out Of Stock').addClass('disabled').prop('disabled', true);
    } else {
      $personalizeBlock.show();
      $bisBlock.hide();
      $('.js-add-to-cart-stock').removeClass('disabled').prop('disabled', false).val('Add To Bag');
    }

    // add to cart
    $('.js-add-to-cart-desktop').attr('data-cart-add', variantId);
    $idInput.attr('data-variant-stock', variantStock);
    $idInput.attr('data-variant-image', variantImage);
    $idInput.attr('data-variant-title', variantTitle);
    $idInput.attr('data-product-title', productTitle);
    $idInput.attr('data-variant-id', variantId);
    $idInput.attr('data-variant-sale-price', variantSalePrice);
    $idInput.attr('data-variant-price', variantPrice);
  });
};

SB.Product.ProductVariantState = function() {
  // Change URL when swatch is clicked
  $('.info-variants .variant-swatch').on('click', function() {
    var $this = $(this),
        variantUrl = $this.data('product-url'),
        variantCount = $('.info-variants .variant-swatch').length,
        curURL = window.location.href;

    if ( variantCount > 1 ) {
      // console.log('state click')
      history.pushState('foo', 'New Variant Link', variantUrl);
    }
  });

  // Back button refreshes page with correct swatch
  window.addEventListener('popstate', function(event) {
    var r = console.log('refresh for variant, not back')
    if (r == true) {
      history.back();
    } else {
      location.reload();
    }
  }, false);
};

SB.Product.PDP2018 = function() {
  // Get current swatch info
  var currentSwatchTitle = $('.js-swatch-title').html(),
      currentSwatch = $('.js-swatch-color').attr('style'),
      openText = 'Choose Your Fabric &amp; Color';

  // Open Variant selector on click
  $('.pdp__fabrications__group--header').on('click', function() {
    $('.pdp__fabrications').toggleClass('open');
    if($('.pdp__fabrications').hasClass('open')){
      $('.js-swatch-title').html(openText);
      $('.js-swatch-color').attr('style','');
    } else {
      $('.js-swatch-title').html(currentSwatchTitle);
      $('.js-swatch-color').attr('style',currentSwatch);
    }
  });

  // Change swatch preview on hover
  $('.pdp__fabrications__group__swatches__swatch').mouseenter(function() {
      var $this = $(this),
          swatchStyle = $this.attr('style'),
          swatchFabrication = $this.attr('data-product-fabrication'),
          swatchColor = $this.attr('data-product-color'),
          swatchImage = $this.attr('data-product-image'),
          swatchTitle = swatchFabrication+' - '+swatchColor,
          $selectedSlide = $('.slide.is-selected > .slide__image');
          $selectedSlide.css('transition','initial');
      $('.pdp__fabrications').addClass('hover');
      $('.js-swatch-title').html(swatchTitle);
      $('.js-swatch-color').attr('style',swatchStyle);
      if(swatchImage.indexOf('no-image') === -1) {
        $selectedSlide.fadeOut(150).promise().done(function () {
          $selectedSlide.css('background-image', 'url(' + swatchImage + ')').fadeIn(150);
        });
      }
    }).mouseleave(function(){
      var $this = $(this),
          swatchImage = $this.attr('data-product-image');
      $('.pdp__fabrications').removeClass('hover');
      $('.js-swatch-title').html(openText);
      $('.js-swatch-color').attr('style','');
      var $selectedSlide = $('.slide.is-selected > .slide__image');
      if(swatchImage.indexOf('no-image') === -1) {
        $selectedSlide.fadeOut(150).promise().done(function () {
          var originalImage = $selectedSlide.attr('data-bg');
          $selectedSlide.css('background-image', 'url(' + originalImage + ')').fadeIn(150);
        });
      }
  });

  // Product Zoom on Mobile
  $('.slide__mobile-zoom').on('click', function() {
    var container = 'slide__mobile-zoom__container',
        image = $(this).attr('data-image');

    $('.'+container).append('<img src="'+image+'" class="panzoom" />').fadeIn();

    var con = $('.'+container)[0].getBoundingClientRect();

    $('.panzoom').panzoom({
      //contain: "invert", // This should keep it "inbounds", but ends up making it buggy
      startTransform: "matrix(1, 0, 0, 1, -800, -800)",
    });
  });

  // Close Product Zoom on Mobile
  $('.slide__mobile-zoom__close').on('click', function() {
    $('.slide__mobile-zoom__container').fadeOut();
    $('.panzoom').remove();
  });

  // Reorder Swatches
  var $activeSwatch = $('.pdp__fabrications__group__swatches__swatch.active');
  var $activeGroup = $activeSwatch.closest('.pdp__fabrications__group');
  $activeGroup.addClass('active');
  $activeGroup.insertAfter('.pdp__fabrications__group--header');
  $activeSwatch.insertAfter('.pdp__fabrications__group.active .pdp__fabrications__group__active__marker');

  // Sold Out Functions
  $('.bis-trigger:not(.notify)').on('click', function() {
    $('.notify__email').slideDown(400).promise().done(function () {
      $('.bis-trigger').val('Sign Up').addClass('notify');
    });
  });

  $(document).on('click', '.bis-trigger.notify', function(e) {
    e.preventDefault();
    var notificationCallback = function(data) {
      var msg = '';
      if (data.status == 'OK') {
        msg = data.message; // just show the success message
        $('.bis-block').fadeOut(400).promise().done(function () {
          $('.bis-block').html('<h5 class="thank-you">THANK YOU!<br />YOU WILL RECEIVE AN EMAIL WHEN THIS ITEM IS BACK IN STOCK.</h5>').fadeIn(400);
        });
      } else { // it was an error
        for (var k in data.errors) {  // collect all the error messages into a string
          msg += data.errors[k].join();
        }
        $('.bis-email-input').addClass('error');
        $('#notify_email').attr('placeholder', 'Email address is invalid.');
      }
      console.log(msg);
    }

    var email = $('#notify_email').val(),
        variantId = $(this).attr('data-variant-id'),
        productId = $(this).attr('data-product-id');
    BIS.create(email, variantId, productId).then(notificationCallback);
  });
};

SB.Product.VariantsGiftCard = function() {
  // Variant swatch UI
  $('.info-variants .variant-gift-card').on('click', function() {
    var $this = $(this),
        variantTitle = $this.data("variant-title"),
        variantId = $this.data("variant-id"),
        $idInput = $this.closest('.wrap').find('#variantId');

    // Reset all swatches
    $this.siblings().removeClass('active');

    // Select new active swatch
    $this.addClass('active');

    // Set Variant ID form field
    $idInput.val(variantId);
  });
};

SB.Product.VariantsShirt = function() {
  // Variant swatch UI
  $('.info-variants .variant-shirt-item').on('click', function() {
    var $this = $(this),
        variantTitle = $this.data("variant-title"),
        variantStock = $this.data("variant-stock"),
        variantId = $this.data("variant-id"),
        $idInput = $this.closest('.wrap').find('#variantId');

    // Reset all swatches
    $this.siblings().removeClass('active');

    // Select new active swatch
    $this.addClass('active');

    $idInput.attr('data-variant-stock', variantStock);
    $idInput.val(variantId);
    $('.js-add-to-cart-desktop').attr('data-cart-add', variantId);

    // stock check
    if ( variantStock == "out-of-stock" ) {
      $('.js-add-to-cart-stock').val('Out Of Stock').addClass('disabled').prop('disabled', true);
    } else {
      $('.js-add-to-cart-stock').removeClass('disabled').prop('disabled', false).val('Add To Bag');
    }

  });
};

SB.Product.Slider = function() {
  var $carousel = $('.pdp__main__gallery__carousel').flickity({
    prevNextButtons: false,
    pageDots: true,
    setGallerySize: false,
    cellAlign: 'left',
    draggable: Modernizr.touchevents
  });

  // $('.product-gallery').addClass('show');
  // $('.image-loading').hide();

  var flkty = $carousel.data('flickity');

  var $cellButtonGroup = $('.pdp__main__gallery__thumbs');
  var $cellButtons = $cellButtonGroup.find('.thumb');

  $carousel.on( 'select.flickity', function() {
    $cellButtons.filter('.active')
      .removeClass('active');
    $cellButtons.eq( flkty.selectedIndex )
      .addClass('active');
  });

  $cellButtonGroup.on( 'click', '.thumb', function() {
    var index = $(this).index();
    $carousel.flickity( 'select', index );
    $('.slide').removeClass('zoom-activated');
  });

  if ( !$carousel.find('.slide').hasClass('zoom-activated') ) {
    $('.slide').on('click', function() {
      $(this).toggleClass('zoom-activated');
      $carousel.find('.zoo-img').remove();
      $carousel.find('.zoo-item').ZooMove();
      $(this).find('.zoo-item').trigger('mousemove');

      // function pageScroll() {
      //   window.scrollBy(0,1); // horizontal and vertical scroll increments
      // }
      //
      // pageScroll();
    });
  } else {
    $carousel.find('.slide').toggleClass('zoom-activated');
  }
};


SB.Product.Personalization = function() {
  var HEART_SYMBOL = '♥';
  var VALID_TEXT_REGEX = /^[A-Z _ a-z _ 0-9 _:;()&\-#@]+$/;

  //
  // === jQuery bindings for showing views ===
  //
  var $body = $('body');
  var $productContainer = $('#productContainer');
  var $personalizationContainer = $('#personalizationContainer');
  var $triggerPersonalizationText = $('#triggerPersonalizationText');
  var $triggerPersonalizationSymbols = $('#triggerPersonalizationSymbols');
  var $currentVariantId = $('#variantId');

  var openPersonalization = function() {
    $("html, body").animate({ scrollTop: window.innerWidth > 1024 ? 100 : 0 });
    $body.addClass('personalization-covered');
    $productContainer.fadeOut('fast', function() {
      $personalizationContainer.fadeIn('fast');
    });
  };

  var closePersonalization = function() {
    $("html, body").animate({ scrollTop: 0 });
    $personalizationContainer.fadeOut('fast', function() {
      $body.removeClass('personalization-covered');
      $productContainer.fadeIn('fast');
    });
  };

  $triggerPersonalizationText.on('click', function() {
    var variantId = $currentVariantId.val();
    actions.setVariant(variantId);
    actions.setTab('text');
    openPersonalization();
  });

  $triggerPersonalizationSymbols.on('click', function() {
    var variantId = $currentVariantId.val();
    actions.setVariant(variantId);
    actions.setTab('symbols');
    openPersonalization();
  });

  //
  // === Helpers ===
  //

  function addHeartToText(text, selectionStart, selectionEnd) {
    return text.substring(0, selectionStart) + HEART_SYMBOL + text.substring(selectionEnd);
  }

  //
  // === Store & Mutations ===
  //
  var store = {
    HEART_SYMBOL: HEART_SYMBOL,
    currentTab: 'text',
    isAddingToBag: false,
    isTextEnabled: PERSONALIZATION_TEXT_ENABLED,
    isSymbolsEnabled: PERSONALIZATION_SYMBOLS_ENABLED,

    // Select Dropdowns
    isTextPlacementOpen: false,
    isFontOpen: false,
    isTextColorOpen: false,
    isHeartColorOpen: false,

    // Product Pricing
    currentProductVariant: CURRENT_PRODUCT_VARIANT,
    productVariantPrices: PRODUCT_VARIANT_PRICES,
    textPrice: PERSONALIZATION_TEXT_PRICE,
    symbolsPrices: SYMBOLS_PRICES,

    // Text
    textPlacementImage: TEXT_PLACEMENT_IMAGE,
    textPlacementOptions: TEXT_PLACEMENT_OPTIONS,
    textFontOptions: TEXT_FONT_OPTIONS,
    textColorOptions: TEXT_COLOR_OPTIONS,
    heartColorOptions: HEART_COLOR_OPTIONS,
    text: '',
    textPlacement: null, //TEXT_PLACEMENT_OPTIONS[0],
    textFont: TEXT_FONT_OPTIONS[0],
    textColor: null, //TEXT_COLOR_OPTIONS[0].color,
    heartColor: null, //HEART_COLOR_OPTIONS[0].color,
    textMaxLength: TEXT_MAX_LENGTH,

    // Form Validation
    isTextPlacementInvalid: false,
    isTextInvalid: false,
    isTextColorInvalid: false,
    isHeartColorInvalid: false,
    // isTextFontInvalid,

    // Symbols
    symbolsPlacementImage: SYMBOLS_PLACEMENT_IMAGE,
    currentSymbolsOrder: Array.apply(null, Array(SYMBOLS_PLACEMENT_COUNT)).map(function() {return null}),
    availableSymbols: AVAILABLE_SYMBOLS,
    currentCarouselIndex: 0,
  };

  var actions = {
    closePersonalization: closePersonalization,
    setTab: function(tab) {
      store.isTextInvalid = false;
      store.isTextColorInvalid = false;
      store.isTextPlacementInvalid = false;
      store.isHeartColorInvalid = false;

      store.currentTab = tab;
    },
    setCarouselIndex: function(index) {
      store.currentCarouselIndex = index;
    },
    setVariant: function(variantId) {
      store.currentProductVariant = variantId;
    },
    addHeart: function(selectionStart, selectionEnd) {
      var newText = addHeartToText(store.text, selectionStart, selectionEnd);

      if (newText.length > store.textMaxLength) {
        return;
      } else {
        store.text = newText;
      }
    },

    // Input validation
    setText: function(text) {
      store.text = text;

      if (text.indexOf(HEART_SYMBOL) === -1) {
        store.heartColor = null;
        store.isHeartColorInvalid = false;
      }
    },

    validateTextForm: function() {
      var isFormValid = true;

      if (store.currentTab === 'text' && store.text.length === 0) {
        store.isTextInvalid = true;
        isFormValid = false;
      } else {
        store.isTextInvalid = false;
      }

      if ((store.currentTab === 'text' || store.text.length > 0) && !store.textColor) {
        store.isTextColorInvalid = true;
        isFormValid = false;
      } else {
        store.isTextColorInvalid = false;
      }

      if ((store.currentTab === 'text' || store.text.length > 0) && !store.textPlacement) {
        store.isTextPlacementInvalid = true;
        isFormValid = false;
      } else {
        store.isTextPlacementInvalid = false;
      }

      if (store.text.indexOf(HEART_SYMBOL) > -1 && !store.heartColor) {
        store.isHeartColorInvalid = true;
        isFormValid = false;
      } else {
        store.isHeartColorInvalid = false;
      }

      if (!isFormValid) {
        store.currentTab = 'text';
      }

      return isFormValid;
    },

    // Selects
    setTextPlacement: function(option) {
      store.textPlacement = option;
      store.isTextPlacementOpen = false;
    },
    setFont: function(option) {
      store.textFont = option;
      store.isFontOpen = false;
    },
    setTextColor: function(option) {
      store.textColor = option;
      store.isTextColorOpen = false;
    },
    setHeartColor: function(option) {
      store.heartColor = option;
      store.isHeartColorOpen = false;
    },

    getSymbol: function(symbolId) {
      for (var i = 0; i < store.availableSymbols.length; i++) {
        if (store.availableSymbols[i].id === symbolId) {
          return store.availableSymbols[i];
        }
      }
      return null;
    },
    addSymbol: function(id) {
      for (var i = 0; i < store.currentSymbolsOrder.length; i++) {
        if (store.currentSymbolsOrder[i] === null) {
          store.currentSymbolsOrder[i] = id;
          break;
        }
      }
    },
    removeSymbol: function(index) {
      store.currentSymbolsOrder[index] = null;
    },
    switchSymbolOrder: function() {
      if (store.currentSymbolsOrder.length !== 2) { return; }

      store.currentSymbolsOrder.reverse();
    },
    getTotalPrice: function() {
      var price = store.productVariantPrices[store.currentProductVariant];

      if (store.text.length > 0) {
        price += store.textPrice;
      }

      for (var i = 0; i < store.currentSymbolsOrder.length; i++) {
        if (store.currentSymbolsOrder[i] !== null) {
          price += store.symbolsPrices[store.currentSymbolsOrder[i]];
        }
      }

      return price;
    },
    getTextColorName: function() {
      for (var i = 0; i < store.textColorOptions.length; i++) {
        if (store.textColorOptions[i].color === store.textColor) {
          return store.textColorOptions[i].name;
        }
      }
      return null;
    },
    getHeartColorName: function() {
      for (var i = 0; i < store.heartColorOptions.length; i++) {
        if (store.heartColorOptions[i].color === store.heartColor) {
          return store.heartColorOptions[i].name;
        }
      }
      return null;
    },
    addToBag: function() {
      var personalizeId = Math.floor(Math.random() * 100000);
      var cartRequests = [];

      var isSymbolSelected = false;

      for (var i = 0; i < store.currentSymbolsOrder.length; i++) {
        if (store.currentSymbolsOrder[i] !== null) {
          isSymbolSelected = true;
          break;
        }
      }

      // Symbol personalization
      if (isSymbolSelected) {
        symbolProducts = store.currentSymbolsOrder.forEach(function(symbolId, index) {
          if (!symbolId) return;

          cartRequests.push({
            method: 'POST',
            url: '/cart/add.js',
            dataType: 'JSON',
            data: {
              quantity: 1,
              id: symbolId,
              properties: {
                personalize_id: personalizeId,
                'Symbol Placement': index + 1
              }
            }
          })
        });

        // SHOW CORRECT ORDER IN CART
        cartRequests.reverse();
      }

      // Text Personalization
      if (store.text.length > 0) {
        var textPersonalizationData = {
          quantity: 1,
          id: PERSONALIZATION_TEXT_VARIANT_ID,
          properties: {
            personalize_id: personalizeId,
            'Text': store.text,
            'Text Placement': store.textPlacement,
            'Text Font': store.textFont,
            'Text Color': actions.getTextColorName(),
          }
        };

        if (store.text.indexOf(HEART_SYMBOL) > -1) {
          textPersonalizationData.properties['Heart Color'] = actions.getHeartColorName()
        }

        cartRequests.push({
          method: 'POST',
          url: '/cart/add.js',
          dataType: 'JSON',
          data: textPersonalizationData
        })
      }

      // Product Variant
      cartRequests.push({
        url: '/cart/add.js',
        method: 'POST',
        quantity: 1,
        dataType: 'JSON',
        data: {
          id: $('#variantId').val(),
          properties: {
            personalize_id: personalizeId
          },
        }
      });

      store.isAddingToBag = true;

      var addAllToCart = function(requests, index, callback) {
        var request = requests[index];
        if (request) {
          $.ajax(request)
          .done(function() {
            addAllToCart(requests, index + 1, callback);
          });
        } else {
          $.get('/cart.json')
          .then(function(data) {
            callback(data);
          });
        }
      };

      addAllToCart(cartRequests, 0, function success(cart) {
        store.isAddingToBag = false;
        window.location.href = '/cart';
      });
    }
  };

  //
  // === Initialize Vue ===
  //
  var view = new Vue({
    el: '#personalizationForm',
    data: store,
    methods: {
      setTab: actions.setTab,
      closePersonalization: actions.closePersonalization,
      switchSymbolOrder: actions.switchSymbolOrder,
      getSymbol: actions.getSymbol,
      getTotalPrice: actions.getTotalPrice,
      getTextColorName: actions.getTextColorName,
      getHeartColorName: actions.getHeartColorName,
      setText: actions.setText,
      setTextPlacement: actions.setTextPlacement,
      setFont: actions.setFont,
      setTextColor: actions.setTextColor,
      setHeartColor: actions.setHeartColor,

      // Input Validation
      preventInvalidInitials: function(event) {
        if (!VALID_TEXT_REGEX.test(event.key)) {
          event.preventDefault();
        } else {
          return true;
        }
      },

      preventInvalidInitialsPaste: function(event) {
        if (!VALID_TEXT_REGEX.test(event.clipboardData.getData('text'))) {
          event.preventDefault();
        } else {
          return true;
        }
      },

      addToBag: function() {
        var isTextFormValid = actions.validateTextForm();

        if (isTextFormValid) {
          actions.addToBag();
        }
      },

      // Add Heart
      // DOM Ref needed
      addHeart: function() {
        var input = this.$refs.customTextInput;
        var inputIsFocused = input === document.activeElement;

        if (inputIsFocused) {
          var selectionStart = input.selectionStart;
          var selectionEnd = input.selectionEnd;

          actions.addHeart(selectionStart, selectionEnd);

        } else {
          actions.addHeart(this.text.length, this.text.length);
          // TODO this doesn't work yet
          setTimeout(function() {
            input.setSelectionRange(store.text.length, 0);
          });
        }
      },

      // Add Symbol
      // Array mutation needed
      addSymbol: function(id) {
        actions.addSymbol(id);
        this.$forceUpdate(); // TODO: replace w/ redux
      },

      // Remove Symbol
      // Array mutation needed
      removeSymbol: function(index) {
        actions.removeSymbol(index);
        this.$forceUpdate(); // TODO: replace w/ redux
      },

      // Template Helpers
      isAddToBagDisabled: function() {
        var hasSymbol = false;

        for (var i = 0; i < store.currentSymbolsOrder.length; i++) {
          if (store.currentSymbolsOrder[i] !== null) {
            hasSymbol = true;
          }
        }

        var isDisabledText = (
          store.currentTab === 'text' &&
          store.text.length === 0 &&
          !hasSymbol
        );

        var isDisabledSymbol = (
          store.currentTab === 'symbols' &&
          !hasSymbol &&
          store.text.length === 0
        );

        return isDisabledText || isDisabledSymbol;
      },

      isSymbolSelected: function(symbolId) {
        for (var i = 0; i < this.currentSymbolsOrder.length; i++) {
          if (this.currentSymbolsOrder[i] === symbolId) {
            return true;
          }
        }
        return false;
      },
      textSplitByHeart: function() {
        return this.text.split(/(♥)/);
      },
      isSwitchButtonAvailable: function() {
        var isSymbolSelected = false;

        for (var i = 0; i < this.currentSymbolsOrder.length; i++) {
          if (this.currentSymbolsOrder[i] !== null) {
            isSymbolSelected = true;
            break;
          }
        }
        return (
          this.currentSymbolsOrder.length > 1 &&
          isSymbolSelected
        )
      }
    },

    mounted: function() {
      var $vm = this;
      var $el = $(this.$el);
      var $symbolCarousel = $el.find('.prod-pers__symbol-carousel').flickity({
        prevNextButtons: false,
        pageDots: false,
        setGallerySize: false,
        cellAlign: 'left'
      });

      $el.find('.prod-pers__carousel-next').on('click', function() {
        $symbolCarousel.flickity('next');
      });
      $el.find('.prod-pers__carousel-previous').on('click', function() {
        $symbolCarousel.flickity('previous');
      });

      $symbolCarousel.on('staticClick.flickity', function(event, pointer, cell, cellIndex) {
        if (cell) {
          var id = $(cell).data('symbol-id');
          actions.addSymbol(id);
          $vm.$forceUpdate(); // TODO: replace w/ redux
        }
      });

      $symbolCarousel.on('select.flickity', function() {
        actions.setCarouselIndex($symbolCarousel.data('flickity').selectedIndex);
      });

      this.$watch('currentTab', function(newVal, oldVal) {
        if (newVal === 'symbols') {
          setTimeout(function() {
            $symbolCarousel.flickity('resize');
          }, 0);
        }
      });

      $(window).on('resize', function() {
        $symbolCarousel.flickity('resize');
      });
    }
  });
};

// ============================================================================
// FAQ
// ============================================================================
SB.Secondary.FAQSidebar = function() {
  if ( $(window).width() >= 641 ) {
    var contentHeight = $('.secondary-main').outerHeight(),
        sidebar = $('.secondary-sidebar'),
        sidebarContentHeight = $('.secondary-sidebar .wrapper').outerHeight(),
        offset = 100,
        stuckPOS = (contentHeight - offset - sidebarContentHeight) * -1;

    $(sidebar).css('height', contentHeight);

    var waypoint = new Waypoint({
      element: document.getElementById('faq-main'),
      handler: function(direction) {
        $('.wrapper').toggleClass('moving');
        $('.wrapper').toggleClass('stuck');
      },
      offset: stuckPOS
    });
  }
};

SB.Secondary.FAQSmoothScroll = function() {
  var offset = 280;

  inactivateLinks = function() {
    $('.sidebar-nav-link').removeClass('active');
  }

  $(function() {
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - offset
          }, 1000);
          return false;
        }
      }
    });
  });

  var down = 0;
  var up = 0;

  $('.sidebar-nav-link').each(function() {
    var curCategory = $(this).data('category');

    var waypointDown = "waypoint_"+down;
    var waypointUp = "waypoint_"+up;

    var waypointDown = new Waypoint({
      element: document.getElementById(curCategory),
      handler: function(direction) {
        if ( direction === "down" ) {
          inactivateLinks();
          $('a[href="#' + curCategory + '"]').addClass('active');
        }
      },
      offset: 280
    });

    var waypointUp = new Waypoint({
      element: document.getElementById(curCategory),
      handler: function(direction) {
        if ( direction === "up" ) {
          inactivateLinks();
          $('a[href="#' + curCategory + '"]').addClass('active');
        }
      },
      offset: 135
    });

    down++;
    up++;
  });
};

// ============================================================================
// SECONDARY
// ============================================================================
SB.Secondary.BlogViewMore = function() {
  $('.js-view-more-posts').on('click', function() {
    var targetSection = $('.post-grid');

    $('html, body').animate({
      scrollTop: targetSection.offset().top - 80
    }, 750);
  });
};

SB.Secondary.WDWTTKSliderMobile = function() {
  var $carousel = $('.js-wdwttk-slider').flickity({
    prevNextButtons: false,
    pageDots: false,
    setGallerySize: false,
    cellAlign: 'left'
  });
};

SB.Secondary.ProjectsSliderMobile = function() {
  var $carousel = $('.js-projects-slider').flickity({
    prevNextButtons: false,
    pageDots: false,
    setGallerySize: false,
    cellAlign: 'left'
  });
};

SB.Secondary.VideoPlayer = function() {
  autoPlayYouTubeModal();
};

// ============================================================================
// ACCOUNT
// ============================================================================
SB.Secondary.AccountPasswordRecovery = function() {
  $('#RecoverPassword').on('click', function() {
    $('#RecoverPasswordForm').show();
    $('#CustomerLoginForm').hide();
  });

  $('#HideRecoverPasswordLink').on('click', function() {
    $('#RecoverPasswordForm').hide();
    $('#CustomerLoginForm').show();
  });

  if (window.location.hash == '#recover') {
    $('#RecoverPasswordForm').show();
    $('#CustomerLoginForm').hide();
  }
};

SB.Secondary.AccountOrderViewing = function() {
  $('.js-toggle-order-view').on('click', function() {
    $(this).closest('.order-item-desktop').toggleClass('open');
    $(this).closest('.order-cta-column').toggleClass('active');

    var el = $(this);
    if (el.text() == el.data("text-swap")) {
      el.text(el.data("text-original"));
    } else {
      el.data("text-original", el.text());
      el.text(el.data("text-swap"));
    }
  });

  $('.js-toggle-order-info').on('click', function() {
    $(this).closest('.order-item-mobile').find('.order-detail-content').toggleClass('visible');
    $(this).closest('.order-viewing').toggleClass('active');

    var el = $(this);
    if (el.text() == el.data("text-swap")) {
      el.text(el.data("text-original"));
    } else {
      el.data("text-original", el.text());
      el.text(el.data("text-swap"));
    }
  });
};

SB.Secondary.AddressSelectUI = function() {
  if ( $(window).width() >= 1010 ) {
    $('.js-custom-dropdown').each(function() {
      var dropdown = $(this),
          dropdownVisibleContainer = $(dropdown).find('.custom-dropdown-items'),
          dropdownItemsContainer = $(dropdown).find('select'),
          dropdownUILabel = $(dropdown).find('.dropdown-value');

      // Build options
      $(dropdownItemsContainer).find('option').each( function() {
        var optionText = $(this).text(),
            optionValue = $(this).val(),
            optionData = $(this).data('provinces');

        $(dropdownVisibleContainer).append('<h5 class="dropdown-option" data-provinces="' + optionData + '" data-sort-value="' + optionValue + '">' + optionText + '</h5>');
      });
    });

    var stopPropagation = function(e) {
      e.stopPropagation();
    }

    // Open dropdown by clicking trigger
    $('.js-custom-dropdown-display').on('click', function() {
      if ($(this).closest('.js-custom-dropdown').find('.custom-dropdown-items').css('display') === 'none') {
        var thisDropdown = $(this).closest('.js-custom-dropdown').find('.custom-dropdown-items');
        $(thisDropdown).css({display: 'block', visibility: 'visible'});

        // Close when clicking outside dropdown
        // Defer adding click listener to window until dropdown is open
        setTimeout(function() {
          $(window).on('click', function() {
            $(thisDropdown).css({display: 'none', visibility: 'hidden'});
          });
          // $(this).closest('.js-custom-dropdown').find('.custom-dropdown-items').on('click', stopPropagation);
        });

        $(this).closest('.js-custom-dropdown').on('click', stopPropagation);
      } else {
        var thisDropdown = $(this).closest('.js-custom-dropdown').find('.custom-dropdown-items');
        $(this).closest('.js-custom-dropdown').find('.custom-dropdown-items').css({display: 'none', visibility: 'hidden'});

        // Remove close listeners
        $(window).off('click', function() {
          $(thisDropdown).css({display: 'none', visibility: 'hidden'});
        });

        $(this).closest('.js-custom-dropdown').off('click', stopPropagation);
      }
    });

    // Option Selected
    $('.js-custom-dropdown').find('.dropdown-option').on('click', function() {
      var dropdown = $(this).closest('.js-custom-dropdown'),
          dropdownVisibleContainer = $(dropdown).find('.custom-dropdown-items'),
          dropdownItemsContainer = $(dropdown).find('select'),
          dropdownUILabel = $(dropdown).find('.dropdown-value'),

          ddOption = $(this).text(),
          ddValue = $(this).data('sort-value'),
          optionData = $(this).data('provinces');

      $(this).closest('.js-custom-dropdown').find('.dropdown-value').text(ddOption);

      $(this).closest('.custom-dropdown-items').removeClass('active').css({display: 'none', visibility: 'hidden'});

      $(dropdownItemsContainer).find('option[value="' + ddValue + '"]').attr('selected','selected');
      $(dropdownItemsContainer).change();
    });
  }
};

SB.Secondary.AccountPage = function() {
  // close new address form
  $('.account-add-new').on('click', function() {
    $(this).hide();
    $('.close-form-new-address').show();
  });

  $('.close-form-new-address').on('click', function() {
    $(this).hide();
    $('.account-add-new').show();
  });

  // Editing Form
  $('.action_edit').on('click', function() {
    var curFormId = $(this).data('form-id');
    $(this).closest('.address-actions').hide();
    $('#EditAddress_' + curFormId + '').show();
  });

  $('.action_delete').on('click', function() {
    var curFormId = $(this).data('form-id');
    $(this).closest('.address-actions').hide();
    $('#EditAddress_' + curFormId + '').hide();
  });

  $('.action_cancel').on('click', function() {
    var curFormId = $(this).data('form-id');
    $(this).closest('.address-grid-item').find('.address-actions').show();
    $('#EditAddress_' + curFormId + '').hide();
  });

  $('.form-group.country').on('click', function() {
    console.log('country click')

  });
}

// ============================================================================
// CART
// ============================================================================
SB.Secondary.CartTemplating = function () {
  var GIFT_WRAP_ID = $('#giftWrapID').val();
  var GIFT_NOTE_ID = $('#giftNoteID').val();
  var INITIALS_UPC = $('#upcID').val();
  var EGIFT_UPC = $('#eGiftUPCID').val();
  var GIFT_WRAP_UPC = $('#giftWrapUPCID').val();


  var $giftNoteEmail = $('#mce-EMAIL');
  var $giftNoteText = $('#mce-GIFTNOTE');
  var $giftModal = $('#giftWrapModal');
  var $cartTemplating = $('#cartTemplating');

  $("#addGiftNote").on('click', function () {
    actions.addGiftNote();
    return false;
  });

  var store = {
    cartItems: [],
    giftWrapID: GIFT_WRAP_ID,
    totalPrice: 0,
    hasEGift: false,
    totalBags: 0,
    disableGiftWrap: false,
    pageLoading: true,
    disableEverything: false,
    invalidEmail: false,
    invalidName: false,
    UPCMapper: window.UPCMapper
  }

  var actions = {
    isEGift: function (item) {
      return item.title === 'E-Gift Note'
    },
    getTotalPrice: function () {
      var totalPrice = 0;
      for (let item of store.cartItems) {
        totalPrice += actions.getSubItemPrice(item);
      }

      return totalPrice;
    },
    getBagCount: function () {
      var count = 0;

      for (let item of store.cartItems) {
        count += item.quantity
      }

      return count;
    },
    hasGiftWrap: function (giftWrap) {
      return Object.keys(giftWrap).length > 0
    },
    checkIfValid: function (email, text) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(email)) {
        $giftNoteEmail.parent().addClass("error");
      } else {
        $giftNoteEmail.parent().removeClass("error");
      }

      if (!text) {
        $giftNoteText.parent().addClass("error");
      } else {
        $giftNoteText.parent().removeClass("error");
      }

      return (text && re.test(email));
    },
    addGiftNote: function () {
      store.disableEverything = true

      var email = $giftNoteEmail.val();
      var text = $giftNoteText.val();

      if (this.checkIfValid(email, text)) {
        $.ajax({
          url: '/cart/add.json',
          method: 'POST',
          quantity: 1,
          dataType: 'JSON',
          data: {
            id: GIFT_NOTE_ID,
            properties: {
              email: email,
              note: text
            },
          }
        })
          .done(function (result) {
            $giftModal.modal('hide');
            actions.getCart();
            $(window).scrollTop();
          });
      }
    },
    getSubItemPrice: function (item) {
      var totalPrice = item.linePrice;
      for (let subItem of item.subItems) {
        totalPrice += (subItem.linePrice);
      }

      totalPrice += (actions.hasGiftWrap(item.giftWrap)) ? item.giftWrap.linePrice : 0

      return totalPrice;
    },
    hasPinOrPatch: function (item) {
      var isPinOrPatch = false;
      for (let subItem of item.subItems) {
        if ((subItem.productType == 'Patch') || (subItem.productType == 'Pin')) {
          isPinOrPatch = true;
          break;
        }
      }

      return isPinOrPatch;
    },
    isPinOrPatch: function (item) {
      return ((item.productType == 'patches') || (item.productType == 'Pin'))
    },
    addGiftWrap: function (item) {

      store.disableGiftWrap = true;

      store.disableEverything = true

      var personalizeID = item.personalizeID
      var lineID = item.line

      var submittedPersonalizedID = (personalizeID === 0) ? Math.floor(Math.random() * 100000) : personalizeID

      $.ajax({
        url: '/cart/change.js',
        method: 'POST',
        dataType: 'JSON',
        data: {
          line: lineID,
          quantity: item.quantity,
          properties: {
            personalize_id: submittedPersonalizedID,
            gift_wrap_id: submittedPersonalizedID
          }
        }
      })
        .done(function (newResult) {
          $.ajax({
            url: '/cart/add.json',
            method: 'POST',
            dataType: 'JSON',
            data: {
              id: GIFT_WRAP_ID,
              quantity: item.quantity,
              properties: {
                gift_wrap_id: submittedPersonalizedID
              },
            }
          })
            .done(function (result) {
              actions.getCart();
              actions.initGiftImagePopover();
            });
        })


    },
    changeQuantity: function (submittedItem, quantity) {
      store.disableEverything = true
      if ((submittedItem.subItems.length > 0) || actions.hasGiftWrap(submittedItem.giftWrap)) {
        $.ajax({
          url: '/cart.json',
          method: 'GET',
          dataType: 'JSON'
        })
          .done(function (result) {
            var newItems = result.items;
            var updateQuantityArray = []

            var personalizeID = submittedItem.personalizeID;

            for (const [index, item] of newItems.entries()) {
              var isChild = (item.properties && item.properties["personalize_id"] && item.properties["personalize_id"] === personalizeID)
              var hasGiftWrap = (actions.hasGiftWrap(submittedItem.giftWrap) && item.properties && item.properties['gift_wrap_id'] && (submittedItem.giftWrap.personalizeID === item.properties['gift_wrap_id']))

              updateQuantityArray.push((isChild || hasGiftWrap) ? quantity : item.quantity)
            }

            jQuery.post('/cart/update.json', { updates: updateQuantityArray }, function (result) {
              actions.getCart();
            });
          });
      } else {
        $.ajax({
          url: '/cart/change.js',
          method: 'POST',
          dataType: 'JSON',
          data: {
            line: submittedItem.line,
            quantity: quantity
          }
        })
          .done(function () {
            actions.getCart();
          })
      }
    },
    setTotalBags: function () {
      store.totalBags = 0;
      for (let item of store.cartItems) {
        if (item.giftWrapEnabled) {
          store.totalBags += item.quantity
        }
      }
    },
    sortCart: function (items) {
      var mainObject = {}
      var parents = {}
      var keyToLine = {}
      var giftWrapImages = [];

      $.ajax("/products/gift-wrap.json")
        .done(function (result) {
          for (let image of result.product.images) {
            giftWrapImages.push(image.src);
          }
        });

      var counter = 1

      store.hasEGift = false;

      for (let item of items) {
        // keep track of the line item order
        keyToLine[item.key] = counter
        counter += 1

        var product_type = item.product_type.toLowerCase();

        // if it doesn't have flare
        if (item.product_type === '') {
          mainObject[item.key] = {
            id: item.key,
            line: keyToLine[item.key],
            variantID: item.id,
            tags: "",
            title: item.product_title,
            handle: item.handle,
            price: 0,
            originalPrice: item.price,
            linePrice: item.line_price,
            variant: (item.variant_options) ? item.variant_options[0] : null,
            image: item.image,
            url: item.url,
            personalizeID: 0,
            quantity: item.quantity,
            sku: item.sku,
            productType: item.product_type,
            giftWrapEnabled: false,
            giftWrap: {},
            subItems: [],
            giftWrapImage: "",
            upc: store.UPCMapper[item.id]
          }
        } else if (!item.properties) {
          mainObject[item.key] = {
            id: item.key,
            line: keyToLine[item.key],
            variantID: item.id,
            tags: "",
            title: item.product_title,
            handle: item.handle,
            price: 0,
            originalPrice: item.price,
            linePrice: item.line_price,
            variant: (item.variant_options) ? item.variant_options[0] : null,
            image: item.image,
            url: item.url,
            personalizeID: 0,
            quantity: item.quantity,
            sku: item.sku,
            productType: item.product_type,
            giftWrapEnabled: true,
            giftWrap: {},
            subItems: [],
            giftWrapImage: "",
            upc: store.UPCMapper[item.id]
          }
        } else if ((product_type === 'bag') || (product_type === 'tote')) {

          mainObject[item.key] = {
            id: item.key,
            line: keyToLine[item.key],
            variantID: item.id,
            tags: "",
            title: item.product_title,
            handle: item.handle,
            price: 0,
            linePrice: item.line_price,
            originalPrice: item.price,
            variant: (item.variant_options) ? item.variant_options[0] : null,
            image: item.image,
            url: item.url,
            personalizeID: item.properties['personalize_id'],
            quantity: item.quantity,
            sku: item.sku,
            productType: item.product_type,
            giftWrapEnabled: true,
            properties: item.properties,
            giftWrap: {},
            subItems: [],
            giftWrapImage: "",
            upc: store.UPCMapper[item.id]
          }

          parents[item.properties['personalize_id']] = item.key;
        } else if (item.product_title === 'E-Gift Note') {
          store.hasEGift = true;

          mainObject[item.key] = {
            id: item.key,
            line: keyToLine[item.key],
            variantID: item.id,
            tags: "",
            title: item.product_title,
            handle: item.handle,
            email: item.properties['email'],
            note: item.properties['note'],
            price: 0,
            originalPrice: item.price,
            linePrice: item.line_price,
            variant: (item.variant_options) ? item.variant_options[0] : null,
            image: item.image,
            url: item.url,
            personalizeID: null,
            quantity: item.quantity,
            sku: item.sku,
            productType: item.product_type,
            giftWrapEnabled: false,
            properties: item.properties,
            giftWrap: {},
            subItems: [],
            giftWrapImage: "",
            upc: EGIFT_UPC
          }
        }

        // console.log('this product has tags ' + tags);

      }

      for (let item of items) {
        var product_type = item.product_type.toLowerCase();

        var isPersonalizedItem = ((item.properties) && (product_type !== 'bag') && (product_type !== 'tote'))

        if (isPersonalizedItem && (item.properties['personalize_id'])) {

          var subItemPersonalizedID = item.properties['personalize_id']

          var main = mainObject[parents[subItemPersonalizedID]];

          if (main) {
            main.total_price += item.price;

            var orderValue = 0

            var productType = item.product_title;
            var display = item.product_title;

            if (item.product_title == 'Initials') {
              orderValue = 1;
              display = `"${item.properties['Text']}"`
            } else if (item.product_title == 'Symbol') {
              display = item.variant_options[0];
              orderValue = 2;
            } else if (item.product_type == 'patches') {
              orderValue = 3;
              productType = "Patch"
            } else if (item.product_type == 'Pin') {
              orderValue = 4;
              productType = "Pin"
            }

            var subItem = {
              id: item.key,
              line: keyToLine[item.key],
              orderValue: orderValue,
              variantID: item.id,
              title: item.product_title,
              price: 0,
              originalPrice: item.price,
              linePrice: item.line_price,
              variant: (item.variant_options) ? item.variant_options[0] : null,
              image: item.image,
              text: item.properties['Text'],
              url: item.url,
              personalizeID: subItemPersonalizedID,
              quantity: item.quantity,
              sku: item.sku,
              display: display,
              productType: productType,
              properties: item.properties,
              upc: store.UPCMapper[item.id]
            }

            mainObject[parents[subItemPersonalizedID]].subItems.push(subItem)
          }
        } else if (isPersonalizedItem && (item.properties['gift_wrap_id'])) {

          var subItemPersonalizedID = item.properties['gift_wrap_id']

          var main = mainObject[parents[subItemPersonalizedID]];

          if (main) {
            main.total_price += item.price;
            mainObject[parents[subItemPersonalizedID]].giftWrap = {
              id: item.key,
              line: keyToLine[item.key],
              variantID: item.id,
              title: item.product_title,
              price: 0,
              originalPrice: item.price,
              linePrice: item.line_price,
              variant: (item.variant_options) ? item.variant_options[0] : null,
              image: item.image,
              text: item.properties['Text'],
              url: item.url,
              personalizeID: subItemPersonalizedID,
              quantity: item.quantity,
              sku: item.sku,
              productType: item.product_type,
              properties: item.properties,
              upc: GIFT_WRAP_UPC
            }
          }
        }
      }

      var sortedItems = [];
      var handleRequests = [];

      for (var key in mainObject) {

        var request = {
          request: {
            url: `/products/${mainObject[key].handle}.json`,
            method: 'GET',
            dataType: 'JSON'
          },
          key: key
        }

        handleRequests.push(request);
      }

      var getProductInfo = function (requests, index, callback) {
        var request = requests[index];
        if (request) {
          $.ajax(request.request)
            .done(function (result) {
              mainObject[request.key].giftWrapEnabled = (
                mainObject[request.key].giftWrapEnabled && (!result.product.tags.includes("no-giftwrap"))
              )
              mainObject[request.key].tags = result.product.tags

              mainObject[request.key].giftWrapImage = giftWrapImages[3];

              if (result.product.tags.includes("giftwrap-xsmall")) {
                mainObject[request.key].giftWrapImage = giftWrapImages[1];
              } else if (result.product.tags.includes("giftwrap-small")) {
                mainObject[request.key].giftWrapImage = giftWrapImages[2];
              } else if (result.product.tags.includes("giftwrap-medium")) {
                mainObject[request.key].giftWrapImage = giftWrapImages[3];
              } else if (result.product.tags.includes("giftwrap-large")) {
                mainObject[request.key].giftWrapImage = giftWrapImages[4];
              } else if (result.product.tags.includes("giftwrap-xlarge")) {
                mainObject[request.key].giftWrapImage = giftWrapImages[5];
              }

              sortedItems.push(mainObject[request.key])
              getProductInfo(requests, index + 1, callback);
            });
        } else {
          $.ajax({
            url: '/cart.js',
            method: 'GET',
            dataType: 'JSON'
          })
            .done(function (data) {
              callback(data);
            })
        }
      };

      getProductInfo(handleRequests, 0, function success(cart) {
        let note = ""

        for (let currentItem of sortedItems) {

          for (let i = 0; i < currentItem.quantity; i++) {
            if (currentItem.subItems.length > 0) {
              note += `(PRODUCT: EMBROIDERY ${currentItem.title} / UPC: ${currentItem.upc})`

              for (var key in currentItem.properties) {
                if (currentItem.properties.hasOwnProperty(key)) {
                  note += `, ${key}: ${currentItem.properties[key]}`
                }
              }

              for (let subItem of currentItem.subItems) {

                if (subItem.title === "Symbol") {
                  note += `, (PRODUCT: ${subItem.title} / SKU: ${subItem.sku})`
                } else {
                  note += `, (PRODUCT: ${subItem.title} / UPC: ${subItem.upc})`
                }

                for (var key in subItem.properties) {
                  if (subItem.properties.hasOwnProperty(key)) {
                    note += `, ${key}: ${subItem.properties[key]}`
                  }
                }
              }

              if (actions.hasGiftWrap(currentItem.giftWrap)) {

                note += `, (PRODUCT: Gift Wrap / UPC: ${currentItem.giftWrap.upc})`
                for (var key in currentItem.giftWrap.properties) {
                  if (currentItem.giftWrap.properties.hasOwnProperty(key)) {
                    note += `, ${key}: ${currentItem.giftWrap.properties[key]}`
                  }
                }
              }

              note += `,`

            } else if (actions.hasGiftWrap(currentItem.giftWrap)) {

              note += `(PRODUCT: ${currentItem.title} / UPC: ${currentItem.upc})`

              for (var key in currentItem.properties) {
                if (currentItem.properties.hasOwnProperty(key)) {
                  note += `, ${key}: ${currentItem.properties[key]}`
                }
              }

              note += `, (PRODUCT: Gift Wrap / UPC: ${currentItem.giftWrap.upc})`

              for (var key in currentItem.giftWrap.properties) {
                if (currentItem.giftWrap.properties.hasOwnProperty(key)) {
                  note += `, ${key}: ${currentItem.giftWrap.properties[key]}`
                }
              }

              note += `,`

            } else if (currentItem.title === "E-Gift Note") {

              note += `(PRODUCT: ${currentItem.title} / UPC: ${currentItem.upc})`

              for (var key in currentItem.properties) {
                if (currentItem.properties.hasOwnProperty(key)) {
                  note += `, ${key}: ${currentItem.properties[key]}`
                }
              }

              note += `,`
            }
          }

          currentItem.subItems.sort(function (a, b) {
            return a.orderValue - b.orderValue;
          });
        }

        // console.log(note);

        $("#hiddenNote").val(note);

        actions.setCart(sortedItems)

      });

      return true;
    },
    setCart: function (items) {
      store.cartItems = items;
      actions.setTotalBags();
      store.pageLoading = false;
      store.disableGiftWrap = false;
      actions.initGiftImagePopover();
    },
    getCart: function () {
      $.ajax({
        url: '/cart.js',
        method: 'GET',
        dataType: 'JSON'
      })
      .done(function (result) {
        actions.sortCart(result.items);
        store.disableEverything = false
        actions.initGiftImagePopover();
      })
    },
    removeItem: function (line, subItems) {
      $.ajax({
        url: '/cart/change.js',
        method: 'POST',
        dataType: 'JSON',
        data: {
          line: line,
          quantity: 0
        }
      })
        .done(function () {
          actions.getCart();
          actions.initGiftImagePopover();
        })
    },
    initGiftImagePopover: function () {
      // console.log('gift wrap function')

      setTimeout(function () {
        $("[data-toggle=popover]").each(function (i, obj) {
          $(this).popover({
            html: true,
            content: function () {
              var id = $(this).attr('id')
              return $('#popover-content-' + id).html();
            }
          });
        });
      }, 200);
    }
  }

  //
  // === Initialize Vue ===
  //
  var view = new Vue({
    el: '#cartTemplating',
    data: store,
    methods: {
      getTotalPrice: actions.getTotalPrice,
      getSubItemPrice: actions.getSubItemPrice,
      getCart: actions.getCart,
      isEGift: function (item) {
        return actions.isEGift(item)
      },
      isPinOrPatch: function (item) {
        return actions.isPinOrPatch(item)
      },
      hasPinOrPatch: function (item) {
        return actions.hasPinOrPatch(item)
      },
      hasGiftWrap: function (giftWrap) {
        return actions.hasGiftWrap(giftWrap);
      },
      removeItem: function (lineID, subItems) {
        actions.removeItem(lineID, subItems)
      },
      removeAll: function (lineID) {
        $.post('/cart/clear.js');
      },
      addGiftWrap: function (item) {
        actions.addGiftWrap(item)
      },
      quantityClicked: function (item, quantity) {
        actions.changeQuantity(item, quantity)
      },
      removeAllItems: function (item) {
        actions.changeQuantity(item, 0)
      },
      changeQuantity: function (item, quantity) {
        actions.changeQuantity(item, item.quantity)
      },
      getBagCount: function () {
        return actions.getBagCount();
      }
    },
    mounted: function () {
      var $vm = this;
      var $el = $(this.$el);
      actions.getCart();
    }
  });
};

/*
   checkout JS for Gift Wrap info
      setTimeout(function() {
        if ( $('.product__description__property').text().indexOf('Gift Recipient') >= 0 ) {
          window.giftRecipientString = $('.product__description__property:contains("Gift Recipient")');
          window.giftRecipient = $(giftRecipientString).text().split(': ').pop();
          $('#gift-recipient').val(giftRecipient);
        } else {
          window.giftRecipient = '';
        }

        if ( $('.product__description__property').text().indexOf('Gift Note') >= 0 ) {
          window.giftNoteString = $('.product__description__property:contains("Gift Note")');
          window.giftNote = $(giftNoteString).text().split(': ').pop();
          $('#gift-note').val(giftNote);
        } else {
          window.giftNote = '';
        }
      }, 150);

      setTimeout(function() {
        if ( giftRecipient != '' ) {
          submitGiftForm = function() {
            $('#giftWrapForm').submit(function(event) {
              event.preventDefault();

              var formEl = $(this);
              var submitButton = $('#giftWrapFormSubmit', formEl);

              $.ajax({
                type: 'POST',
                url: formEl.prop('action'),
                accept: {
                  javascript: 'application/javascript'
                },
                data: $('#giftWrapForm').serializeArray(),
                beforeSend: function() {
                  console.log('sending')
                  submitButton.prop('disabled', 'disabled');
                }
              }).done(function(data) {
                submitButton.prop('disabled', false);
              });
            });
          };

          setTimeout(function() {
            submitGiftForm();
            $('#giftWrapFormSubmit').trigger( "click" );
          }, 100);
        }
      }, 250);

*/

// ============================================================================
// STAR WARS
// ============================================================================
SB.Secondary.StarWarsHero = function() {
  $(".star-wars__header-stars").addClass('visible');

  var waypointSectionOne = new Waypoint({
    element: document.getElementById('section-one'),
    handler: function(direction) {
      if ( direction === 'down' ) {
        $('.page-marker').css('top', '226px');
      }

      if ( direction === 'up' ) {
        $('.page-marker').css('top', '195px');
      }
    },
    offset: 600
  });

  var waypointSectionOne = new Waypoint({
    element: document.getElementById('section-two'),
    handler: function(direction) {
      if ( direction === 'down' ) {
        $('.page-marker').css('top', '258px');
      }

      if ( direction === 'up' ) {
        $('.page-marker').css('top', '226px');
      }
    },
    offset: 600
  });

  var waypointSectionOne = new Waypoint({
    element: document.getElementById('section-three'),
    handler: function(direction) {
      if ( direction === 'down' ) {
        $('.page-marker').css('top', '289px');
      }

      if ( direction === 'up' ) {
        $('.page-marker').css('top', '258px');
      }
    },
    offset: 600
  });
};


SB.Secondary.MobileProductSliderFriendshipOne = function() {
  var $carousel = $('.js-group-block--mobile-slider-one').flickity({
    prevNextButtons: false,
    pageDots: false,
    cellSelector: '.carousel-cell',
    imagesLoaded: true,
    cellAlign: 'left'
  });

  // Flickity instance
  var flkty = $carousel.data('flickity');

  // elements
  var $cellButtonGroup = $('.button-group-slider-one--cells');
  var $cellButtons = $cellButtonGroup.find('.button');

  // update selected cellButtons
  $carousel.on( 'select.flickity', function() {
    var selectedSlide = $cellButtons.eq(flkty.selectedIndex).data('slide');
    console.log(selectedSlide);

    $cellButtons.filter('.is-selected')
      .removeClass('is-selected');
    $cellButtons.eq( flkty.selectedIndex )
      .addClass('is-selected');

    $('.group-block--mobile-slider-one-copy .slide-copy').removeClass('slide--active');
    $('.group-block--mobile-slider-one-copy .slide-copy[data-slide="' + selectedSlide + '"]').addClass('slide--active');
  });

  // select cell on button click
  $cellButtonGroup.on( 'click', '.button', function() {
    var index = $(this).index();
    $carousel.flickity( 'select', index );
    console.log(index + 1)

    $('.group-block--mobile-slider-one-copy .slide-copy').removeClass('slide--active');
    $('.group-block--mobile-slider-one-copy .slide-copy[data-slide="' + (index + 1) + '"]').addClass('slide--active');

    $('.js-group-block--mobile-slider-one-link').removeClass('slide--active');
    $('.js-group-block--mobile-slider-one-link[data-slide="' + (index + 1) + '"]').addClass('slide--active');
  });
};

SB.Secondary.MobileProductSliderFriendshipTwo = function() {
  var $carousel = $('.js-group-block--mobile-slider-two').flickity({
    prevNextButtons: false,
    pageDots: false,
    cellSelector: '.carousel-cell',
    imagesLoaded: true,
    cellAlign: 'left'
  });

  // Flickity instance
  var flkty = $carousel.data('flickity');

  // elements
  var $cellButtonGroup = $('.button-group-slider-two--cells');
  var $cellButtons = $cellButtonGroup.find('.button');

  // update selected cellButtons
  $carousel.on( 'select.flickity', function() {
    var selectedSlide = $cellButtons.eq(flkty.selectedIndex).data('slide');

    $cellButtons.filter('.is-selected')
      .removeClass('is-selected');
    $cellButtons.eq( flkty.selectedIndex )
      .addClass('is-selected');

    $('.group-block--mobile-slider-two-copy .slide-copy').removeClass('slide--active');
    $('.group-block--mobile-slider-two-copy .slide-copy[data-slide="' + selectedSlide + '"]').addClass('slide--active');
  });

  // select cell on button click
  $cellButtonGroup.on( 'click', '.button', function() {
    var index = $(this).index();
    $carousel.flickity( 'select', index );
    console.log(index + 1)

    $('.group-block--mobile-slider-two-copy .slide-copy').removeClass('slide--active');
    $('.group-block--mobile-slider-two-copy .slide-copy[data-slide="' + (index + 1) + '"]').addClass('slide--active');

    $('.js-group-block--mobile-slider-two-link').removeClass('slide--active');
    $('.js-group-block--mobile-slider-two-link[data-slide="' + (index + 1) + '"]').addClass('slide--active');
  });
};


SB.Secondary.MobileProductSliderFriendshipThree = function() {
  var $carousel = $('.js-group-block--mobile-slider-three').flickity({
    prevNextButtons: false,
    pageDots: false,
    cellSelector: '.carousel-cell',
    imagesLoaded: true,
    cellAlign: 'left'
  });

  // Flickity instance
  var flkty = $carousel.data('flickity');

  // elements
  var $cellButtonGroup = $('.button-group-slider-three--cells');
  var $cellButtons = $cellButtonGroup.find('.button');

  // update selected cellButtons
  $carousel.on( 'select.flickity', function() {
    var selectedSlide = $cellButtons.eq(flkty.selectedIndex).data('slide');

    $cellButtons.filter('.is-selected')
      .removeClass('is-selected');
    $cellButtons.eq( flkty.selectedIndex )
      .addClass('is-selected');

    $('.group-block--mobile-slider-three-copy .slide-copy').removeClass('slide--active');
    $('.group-block--mobile-slider-three-copy .slide-copy[data-slide="' + selectedSlide + '"]').addClass('slide--active');
  });

  // select cell on button click
  $cellButtonGroup.on( 'click', '.button', function() {
    var index = $(this).index();
    $carousel.flickity( 'select', index );
    console.log(index + 1)

    $('.group-block--mobile-slider-three-copy .slide-copy').removeClass('slide--active');
    $('.group-block--mobile-slider-three-copy .slide-copy[data-slide="' + (index + 1) + '"]').addClass('slide--active');

    $('.js-group-block--mobile-slider-three-link').removeClass('slide--active');
    $('.js-group-block--mobile-slider-three-link[data-slide="' + (index + 1) + '"]').addClass('slide--active');
  });
};

SB.Product.RelatedItemsSlider = function() {
  var $carousel = $('.js-sw-related-products__slider').flickity({
    prevNextButtons: true,
    pageDots: false,
    cellSelector: '.product-grid-item',
    imagesLoaded: true,
    initialIndex: 1,
    wrapAround: true
  });

  // previous
  $('.sw-slider__arrow-left').on( 'click', function() {
    $carousel.flickity('previous');
  });

  // next
  $('.sw-slider__arrow-right').on( 'click', function() {
    $carousel.flickity('next');
  });

  var $carouselMobile = $('.js-sw-related-products__slider--mobile').flickity({
    prevNextButtons: false,
    pageDots: false,
    cellSelector: '.product-grid-item',
    imagesLoaded: true,
    cellAlign: 'left'
  });

  $(function(){
    var starString = [],
        star;

    for (var i = 0; i < 11000; i++) {
      star = Math.random();
      starString.push( star > 0.95 ? '<span class="star--small">.</span>' : star < 0.015 ? '*' : ' <span>&nbsp;</span>')
    }

    $(".js-sw-related-products").html(starString.join(""));
  });
}


SB.Collection.CollectionSmoothScroll = function() {
  var offset = 100;

  inactivateLinks = function() {
    $('.nav-item').removeClass('active');
  }

  $(function() {
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - offset
          }, 1000);
          return false;
        }
      }
    });
  });

  var down = 0;
  var up = 0;

  $('.shop-by-style-nav-item').each(function() {
    var curCategory = $(this).data('category');

    var waypointDown = "waypoint_"+down;
    var waypointUp = "waypoint_"+up;

    var waypointDown = new Waypoint({
      element: document.getElementById(curCategory),
      handler: function(direction) {
        if ( direction === "down" ) {
          inactivateLinks();
          $('a[href="#' + curCategory + '"]').addClass('active');
        }
      },
      offset: 280
    });

    var waypointUp = new Waypoint({
      element: document.getElementById(curCategory),
      handler: function(direction) {
        if ( direction === "up" ) {
          inactivateLinks();
          $('a[href="#' + curCategory + '"]').addClass('active');
        }
      },
      offset: 135
    });

    down++;
    up++;
  });
};

SB.Collection.StickySidebar = function() {
  var waypointCollectionSidebar = new Waypoint({
    element: document.getElementById('collection-sidebar'),
    handler: function(direction) {
      if ( direction === "down" ) {
        $('.collection-body-side-inner').addClass('fixed');
      }

      if ( direction === "up" ) {
        $('.collection-body-side-inner').removeClass('fixed');
      }
    },
    offset: 100
  });
};

SB.Secondary.GiftNoteCount = function() {
  $("#mce-GIFTNOTE").on('keyup', function(event) {
      var currentString = $("#mce-GIFTNOTE").val()

      if (currentString.length <= 250 )  {  /*or whatever your number is*/
        // adding note
        $(".gift-note-count").html(250 - currentString.length);
      } else if (currentString.length == 0 ) {
        // no more room
      }
  });
};

SB.Secondary.SweepStakesForm = function() {
  console.log("init sweepstakes");

  $('#sweepstakesForm').validetta({
    realTime: true,
    errorClose: false,
    bubblePosition: 'bottom',
    onValid: function(event) {
      event.preventDefault();

      var form = $(this),
          submit = $('#submit', form),
          data = {
            'firstName' : $('#first_name').val(),
            'lastName' : $('#last_name').val(),
            'email' : $('#email').val(),
          };

      $.ajax({
        type: 'POST',
        url: $(this.form).prop('action'),
        data: data,
        beforeSend: function() {
          submit.prop('disabled', 'disabled');
        },
        complete: function() {
          $('.sweeps__form_wrapper').fadeOut(200, function() {
            $('.sweeps__form_success').fadeIn();
          });
        }
      });
    },
    onError: function(event) {
      event.preventDefault();
    }
  });
};

SB.Secondary.YYSlider = function() {
  var $carousel = $('[data-yy-footer-slider]').flickity({
    prevNextButtons: false,
    pageDots: false,
    setGallerySize: false
  });
}

SB.Secondary.GiftGuidePromo = function() {
  var shoppingForSelect = $('#shopping-for');
  var giftObject = [];

  $('.gift-guide-select').selectric({
    onInit: function() {
      $('.gift-guide__form').addClass('visible');
    },
  });

  if ( $('#shopping-age').find("option:selected").data('open-question-three') != undefined ) {
    $('[data-question-three]').removeClass('hidden');
    var selectedPurpose = $('#shopping-purpose').val();
  }

  $('.gift-guide-select').on('change', function() {

    // New values
    var selectedFor = $('#shopping-for').val(),
        selectedAge = $('#shopping-age').val();

    // Clear object
    giftObject = [];

    // Fill Object with new values
    giftObject.push(selectedFor)
    giftObject.push(selectedAge)
    // giftObject.push(selectedPurpose)

    // gift choices
    // console.log(giftObject);
    // console.log(JSON.stringify(giftObject));

    // hide or show question 3
    if ( $('#shopping-age').find("option:selected").data('open-question-three') != undefined ) {
      $('.gift-guide__form').addClass('gift-guide__form--taller');
      $('[data-question-three]').removeClass('hidden');
      var selectedPurpose = $('#shopping-purpose').val();
      giftObject.push(selectedPurpose);
      // console.log(giftObject);
      // console.log(JSON.stringify(giftObject));
    } else {
      $('[data-question-three]').addClass('hidden');
    }

    // Functions for URL updating
    function containsGiftTerms(desiredTerm, giftTerms){
      for ( var i = 0 , len = desiredTerm.length; i < len; i++ ) {
        if($.inArray(desiredTerm[i], giftTerms) == -1) return false;
      }
      return true;
    }

    function updateGiftCollectionURL(newURL) {
      $('[data-gift-guide-button]').attr('href', newURL);
    }

    // UPDATE URL based on selected terms
    if ( containsGiftTerms(['lady', 'preschool'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidegirls-tiny-lady');
    } else if ( containsGiftTerms(['lady', 'k-2'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidegirls-little-lady');
    } else if ( containsGiftTerms(['lady', 'bigger-kid'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidegirls-young-ladies');
    } else if ( containsGiftTerms(['lady', 'adult', 'school'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidegirls-young-ladies');
    } else if ( containsGiftTerms(['lady', 'adult', 'work'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidewomen-boss-lady');
    } else if ( containsGiftTerms(['lady', 'adult', 'travel'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidewomen-travel-fitness');
    } else if ( containsGiftTerms(['lady', 'adult', 'everyday'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidewomen-everyday-gal');
    } else if ( containsGiftTerms(['lady', 'adult', 'fashion'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidewomen-fashion-gal');

    } else if ( containsGiftTerms(['dude', 'preschool'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguideboys-tiny-dude');
    } else if ( containsGiftTerms(['dude', 'k-2'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguideboys-little-dude');
    } else if ( containsGiftTerms(['dude', 'bigger-kid'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguideboys-big-dude');
    } else if ( containsGiftTerms(['dude', 'adult', 'school'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguideboys-big-dude');
    } else if ( containsGiftTerms(['dude', 'adult', 'work'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidemen-modern-man');
    } else if ( containsGiftTerms(['dude', 'adult', 'travel'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidemen-travel-and-fitness');
    } else if ( containsGiftTerms(['dude', 'adult', 'everyday'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidemen-everyday-guy');
    } else if ( containsGiftTerms(['dude', 'adult', 'fashion'], giftObject) ) {
      updateGiftCollectionURL('/collections/giftguidemen-modern-man');
    }
  });

  // pronouns
  $(shoppingForSelect).on('change', function() {
    var newValue = this.value;

    if ( newValue == 'dude' ) {
      $('[data-shopping-for-pronoun]').text('Him');
      $('[data-shopping-for-pronoun-two]').text('He');
    } else if ( newValue == 'lady' ) {
      $('[data-shopping-for-pronoun]').text('Her');
      $('[data-shopping-for-pronoun-two]').text('She');
    }
  });
};

SB.Secondary.CartGiftWrapPreview = function() {
  // if (isMobile.apple.device) {
  //   $(':not(#anything)').on('click', function (e) { $('[data-toggle="popover"]').each(function () { if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) { $(this).popover('hide'); } }); });
  // }
};


// ============================================================================
// Shop By Style
// ============================================================================
SB.Secondary.ShopBySyle = function() {
  var offset = 100;

  inactivateLinks = function() {
    $('.nav-item--styles').removeClass('active');
  }

  $(function() {
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - offset
          }, 1000);
          return false;
        }
      }
    });
  });

  var down = 0;
  var up = 0;

  $('.nav-item--styles').each(function() {
    var curStyle = $(this).data('style');

    var waypointDown = "waypoint_"+down;
    var waypointUp = "waypoint_"+up;

    var waypointDown = new Waypoint({
      element: document.getElementById(curStyle),
      handler: function(direction) {
        if ( direction === "down" ) {
          inactivateLinks();
          $('a[href="#' + curStyle + '"]').addClass('active');
        }
      },
      offset: 200
    });

    var waypointUp = new Waypoint({
      element: document.getElementById(curStyle),
      handler: function(direction) {
        if ( direction === "up" ) {
          inactivateLinks();
          $('a[href="#' + curStyle + '"]').addClass('active');
        }
      },
      offset: 200
    });

    down++;
    up++;
  });
};
